import DecoupledEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-react";
import {
  Add,
  Close,
  DateRange,
  Delete,
  Edit,
  HelpOutline,
} from "@material-ui/icons";
import { ContentCopy, OpenInNew } from "@mui/icons-material";
import "bootstrap-daterangepicker/daterangepicker.css";
import { ErrorMessage, Field, Form, Formik } from "formik";
import $ from "jquery";
import moment from "moment";
import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import ReactHtmlParser from "react-html-parser";
import InputMask from "react-input-mask";
import { connect } from "react-redux";
import ReactSelect from "react-select";
import * as Yup from "yup";
import { StatesList } from "../../Helper/StatesList";
import {
  myProfileAction,
  updateProfileAction,
  updateUserProfileAction,
  updateUserTransPaymentAction,
  getUserTransPaymentAction,
  checkDuplicateInvoicePrefixAction,
  checkDuplicatePublicUrlPostfixAction,
  checkArtistDuplicatePublicUrlAction,
} from "./../../actions/UserActions";
import { getAddressFromZipcodeAction } from "./../../actions/commonActions";

import UserImage from "./../../assets/img/property-placeholder.jpg";

import APIUtil from "./../../config/APIUtil";
import UrlConstants from "./../../config/UrlConstants";

import PhoneNumber from "../Common/phoneNumber";
import NumericInput from "react-numeric-input";

import {
  cryptoTokenDecode,
  checkObjExists,
  toastMessage,
  randomCapitalString,
  tranformStrToVar,
  currencyFormat,
} from "./../Common/Common";
import * as message from "./../../config/CommonMessages";
import * as code from "./../../config/Constants";
import {
  getUserCampaignsAction,
  updateUserCampaignDefaultAction,
} from "../../actions/BuyerAgentMasterTemplateActions";
import {
  getUserPathwaysAction,
  updateUserPathwayDefaultAction,
} from "../../actions/PathwayActions";
import { getShopDetailsAction } from "../../actions/ShopActions";

var _ = require("lodash");

const config = {
  fontColor: {
    colors: [
      {
        color: "hsl(0, 0%, 0%)",
        label: "Black",
      },
      {
        color: "hsl(0, 0%, 30%)",
        label: "Dim grey",
      },
      {
        color: "hsl(0, 0%, 60%)",
        label: "Grey",
      },
      {
        color: "hsl(0, 0%, 90%)",
        label: "Light grey",
      },
      {
        color: "hsl(0, 0%, 100%)",
        label: "White",
        hasBorder: true,
      },
    ],
  },
  fontBackgroundColor: {
    colors: [
      {
        color: "hsl(0, 75%, 60%)",
        label: "Red",
      },
      {
        color: "hsl(30, 75%, 60%)",
        label: "Orange",
      },
      {
        color: "hsl(60, 75%, 60%)",
        label: "Yellow",
      },
      {
        color: "hsl(90, 75%, 60%)",
        label: "Light green",
      },
      {
        color: "hsl(120, 75%, 60%)",
        label: "Green",
      },
    ],
  },
  toolbar: [
    "bold",
    "strike",
    "italic",
    "link",
    "bulletedList",
    "numberedList",
    "blockQuote",
    "fontColor",
    "fontBackgroundColor",
  ],
  heading: {
    options: [
      { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
      {
        model: "heading1",
        view: "h1",
        title: "Heading 1",
        class: "ck-heading_heading1",
      },
      {
        model: "heading2",
        view: "h2",
        title: "Heading 2",
        class: "ck-heading_heading2",
      },
    ],
  },
};

var minDate = moment();
const initialCompanyData = {
  name: "",
  website: "",
  address: "",
  zipcode: "",
  city: "",
  state: "",
  phoneNumber: "",
  faxNumber: "",
  typeOfBusiness: "",
  companySize: "",
  publicUrl: "",
  studioLogo: "",
  defaultBookingAmount: "0",
  defaultDuration: "30",
};

const initialSettingData = {
  autoCompleteTransactions: false,
  autoCompleteTransactionsDays: 25,
};

const initialBillingSettingData = {
  billingSettingStatus: false,
  mid: "",
  developerKey: "",
  apiPassword: "",
  invoicePrefix: randomCapitalString(),
  serviceFeeEnabled: false,
  appSource: "",
};

const initialCampaignDefaultSettingData = {
  name: "",
  id: "",
};

const initialPathwayDefaultSettingData = {
  name: "",
  id: "",
};

class UserProfile extends React.Component {
  constructor(props) {
    super(props);

    var userType = cryptoTokenDecode().usertype;

    this.state = {
      userData: {},
      onlyViewMode: false,
      userType: userType.toUpperCase(),
      userInfo: false,
      bioInfo: false,
      deletePrompt: false,

      goalInfo: false,
      goalEdit: false,
      goalData: {},
      goalIndex: "",

      educationInfo: false,
      educationData: {},
      educationEdit: true,
      educationIndex: "",
      educationInfoDate: "",
      educationInfoDate1: "",

      certificationsInfo: false,
      certificationsInfoDate: "",
      certificationsData: {},
      certificationsEdit: false,
      certificationsIndex: "",

      licenseExpDate: "",

      awardsInfo: false,
      awardsInfoDate: "",
      awardsData: {},
      awardsEdit: false,
      awardsIndex: "",

      companyInfo: false,
      startDate: moment(),
      closeDate: moment().subtract(-29, "days"),

      deleteType: "",
      deleteIndex: "",
      showLoader: false,

      brokerageInfo: false,

      signatureInfo: false,
      selectedImage: "",
      profileImage: "",
      fileName: "",
      autocompletesettingmodel: false,
      dsdInfoPrompt: false,

      dsdInfo: {},
      autocompletesetting: initialSettingData,
      dsdEditFlag: false,
      roleShow: "",
      companyData: initialCompanyData ? initialCompanyData : "",

      accOwnerBuyerAgentFlag: false,
      comapanyname: "",

      campaignDefaultSettingPrompt: false,
      campaignDefaultSetting: initialCampaignDefaultSettingData,
      userCampaigns: [],
      pathwayDefaultSettingPrompt: false,
      pathwayDefaultSetting: initialPathwayDefaultSettingData,
      userPathways: [],

      billingSettingModal: false,
      billingSettingData: initialBillingSettingData,

      availabilityInfo: false,
      selectedCompanyLogo: "",
      companyLogo: "",
      amountFocus: false,
      artistPublicUrlInfo: false,
      artistPublicUrlInfoExists: false,
      artistDsdRoleInfo: {},
      ownerId:
        cryptoTokenDecode().usertype === message.ACCTOWNER
          ? localStorage.getItem("ID")
          : localStorage.getItem("ownerId"),
      allowPublicSchedulingErr: false,
      allowPublicProfileUrlErr: false,
    };

    this.props.history.listen((location, action) => {
      let urlPathData = location.pathname.split("/");
      if (
        urlPathData[1].toLowerCase() == "userprofile" &&
        urlPathData[2] === undefined
      ) {
        //if id not exist then load current user profile
        this.props.myProfileAction();
        this.setState({ onlyViewMode: false });
      }

      if (
        urlPathData[1].toLowerCase() == "userprofile" &&
        urlPathData[2] !== undefined
      ) {
        //load profile by id
        let id = urlPathData[2];
        this.props.myProfileAction(id);
        this.setState({ onlyViewMode: true });
      }
    });
  }

  checkPublicProfileUrl(values, setFieldValue, item, itemValue) {
    if (!values.allowPublicProfile) {
      if (itemValue) {
        this.setState({
          allowPublicSchedulingErr: true,
          allowPublicProfileUrlErr: false,
        });
      } else {
        setFieldValue(item, itemValue);
        this.setState({
          allowPublicSchedulingErr: false,
          allowPublicProfileUrlErr: false,
        });
      }
    } else {
      setFieldValue(item, itemValue);
      this.setState({
        allowPublicSchedulingErr: false,
        allowPublicProfileUrlErr: false,
      });
    }
  }

  checkPublicScheduling(values, setFieldValue, item, itemValue) {
    if (values.allowPublicScheduling) {
      if (!itemValue) {
        this.setState({
          allowPublicProfileUrlErr: true,
          allowPublicSchedulingErr: false,
        });
      } else {
        setFieldValue(item, itemValue);
        this.setState({
          allowPublicProfileUrlErr: false,
          allowPublicSchedulingErr: false,
        });
      }
    } else {
      setFieldValue(item, itemValue);
      this.setState({
        allowPublicProfileUrlErr: false,
        allowPublicSchedulingErr: false,
      });
    }
  }

  componentWillMount() {
    // console.log("userType ", this.state.userType);
    if (this.props.match.params.id) {
      let userID = this.props.match.params.id;
      this.setState({
        onlyViewMode: true,
        token: userID,
      });

      // features those are not for vendors those apis don't call
      if (this.state.userType !== message.VENDOR) {
        this.loadUserTransPaymentDetails(userID);
        this.loadUserCampaigns(userID);
        this.loadUserPathways(userID);
      }

      this.props.myProfileAction(userID).then((res) => {
        this.setState({
          userData: this.props.profileData,
        });
        //set default role and related data on profile
        if (
          this.props.profileData.dsd &&
          this.props.profileData.dsd.roles &&
          this.props.profileData.dsd.roles.length > 0
        ) {
          //set first role as default in Role dropdown
          this.getDsdDataByRole(this.props.profileData.dsd.roles[0].roleId);
        } else if (this.props.profileData.usertype === message.ACCTOWNER) {
          // Set roleId if dsd not present for acc owner
          this.setState({
            roleShow: "ACCOWNER",
          });
        }
      });
    } else {
      // features those are not for vendors those apis don't call
      if (this.state.userType !== message.VENDOR) {
        this.loadUserTransPaymentDetails();
        this.loadUserCampaigns();
        this.loadUserPathways();
      }

      this.props.myProfileAction().then((res) => {
        this.setState({
          userData: this.props.profileData,
        });
        //set default role and related data on profile
        if (
          this.props.profileData.dsd &&
          this.props.profileData.dsd.roles &&
          this.props.profileData.dsd.roles.length > 0
        ) {
          //set first role as default in Role dropdown
          this.getDsdDataByRole(this.props.profileData.dsd.roles[0].roleId);
        } else if (this.props.profileData.usertype === message.ACCTOWNER) {
          // Set roleId if dsd not present for acc owner
          this.setState({
            roleShow: "ACCOWNER",
          });
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.renderHeader !== prevProps.renderHeader) {
      let ownerId =
        cryptoTokenDecode().usertype === message.ACCTOWNER
          ? localStorage.getItem("ID")
          : localStorage.getItem("ownerId");
      this.setState({ ownerId: ownerId }, () => {
        this.getDsdDataByRole(
          this.props.profileData &&
            this.props.profileData.dsd &&
            this.props.profileData.dsd.roles &&
            this.props.profileData.dsd.roles.length > 0 &&
            this.props.profileData.dsd.roles[0].roleId
        );
      });
    }
  }

  getShopDetails(ownerId) {
    this.props
      .getShopDetailsAction(ownerId)
      .then((res) => {
        if (res.status === 200) {
          if (res && res.data && res.data.shopDetails) {
            this.setState({
              companyData: res.data.shopDetails,
            });
          } else {
            this.setState({
              companyData: initialCompanyData,
            });
          }
        } else {
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        }
      })
      .catch((err) => {
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
      });
  }

  getDsdDataByRole(roleId) {
    if (
      // for artists
      this.state.userType === message.VENDOR &&
      localStorage.getItem("vendorRoleName") === "Artist"
    ) {
      let roleObj =
        (this.props.profileData &&
          this.props.profileData.dsd &&
          this.props.profileData.dsd.roles &&
          this.props.profileData.dsd.roles.length > 0 &&
          this.props.profileData.dsd.roles.find((o) => o.roleId === roleId)) ||
        {};
      if (roleObj && roleObj !== undefined && checkObjExists(roleObj)) {
        this.setState({
          artistDsdRoleInfo: roleObj,
          roleShow: roleId,
        });
      } else {
        this.setState({
          artistDsdRoleInfo: {},
          roleShow: "",
        });
      }

      this.getShopDetails(this.state.ownerId);

      let defultArtistPublicUrl =
        localStorage.getItem("companyName") +
        " " +
        localStorage.getItem("fname");

      let studioObj =
        (this.props.profileData &&
          this.props.profileData.dsd &&
          this.props.profileData.dsd.studios &&
          this.props.profileData.dsd.studios.length > 0 &&
          this.props.profileData.dsd.studios.find(
            (o) => o.ownerId === this.state.ownerId
          )) ||
        {};
      if (studioObj && studioObj !== undefined && checkObjExists(studioObj)) {
        if (!studioObj.hasOwnProperty("publicUrl")) {
          this.setState({
            artistPublicUrlInfoExists: false,
          });
          studioObj.publicUrl = tranformStrToVar(defultArtistPublicUrl) || "";
        } else {
          this.setState({
            artistPublicUrlInfoExists: true,
          });
        }

        if (!studioObj.hasOwnProperty("defaultBookingAmount")) {
          this.setState({
            artistPublicUrlInfoExists: false,
          });
          studioObj.defaultBookingAmount = "0";
        } else {
          this.setState({
            artistPublicUrlInfoExists: true,
          });
        }

        if (!studioObj.hasOwnProperty("defaultDuration")) {
          studioObj.defaultDuration = "30";
        }

        this.setState({
          dsdInfo: studioObj,
        });
      } else {
        this.setState({
          artistPublicUrlInfoExists: false,
          dsdInfo: {
            publicUrl: tranformStrToVar(defultArtistPublicUrl) || "",
            defaultBookingAmount: "0",
            defaultDuration: "30",
          },
        });
      }
    } else {
      // for account owner
      let defultArtistPublicUrl =
        localStorage.getItem("fname") + " " + localStorage.getItem("lname");

      let roleObj =
        (this.props.profileData &&
          this.props.profileData.dsd &&
          this.props.profileData.dsd.roles &&
          this.props.profileData.dsd.roles.length > 0 &&
          this.props.profileData.dsd.roles.find((o) => o.roleId === roleId)) ||
        {};

      if (roleObj && roleObj !== undefined && checkObjExists(roleObj)) {
        if (!roleObj.hasOwnProperty("defaultDuration")) {
          roleObj.defaultDuration = "30";
        }

        if (!roleObj.hasOwnProperty("publicUrl")) {
          this.setState({
            artistPublicUrlInfoExists: false,
          });
          roleObj.publicUrl = tranformStrToVar(defultArtistPublicUrl) || "";
        } else {
          this.setState({
            artistPublicUrlInfoExists: true,
          });
        }

        if (!roleObj.hasOwnProperty("defaultBookingAmount")) {
          this.setState({
            artistPublicUrlInfoExists: false,
          });
          roleObj.defaultBookingAmount = "0";
        } else {
          this.setState({
            artistPublicUrlInfoExists: true,
          });
        }

        if (!roleObj.hasOwnProperty("allowPublicProfile")) {
          roleObj.allowPublicProfile = false;
        }

        if (!roleObj.hasOwnProperty("allowPublicScheduling")) {
          roleObj.allowPublicScheduling = false;
        }

        if (checkObjExists(roleObj.companyInformation)) {
          if (!roleObj.companyInformation.hasOwnProperty("publicUrl")) {
            roleObj.companyInformation.publicUrl =
              tranformStrToVar(roleObj.companyInformation.name) || "";
          }
          if (
            !roleObj.companyInformation.hasOwnProperty("defaultBookingAmount")
          ) {
            roleObj.companyInformation.defaultBookingAmount = "0";
          }
          if (!roleObj.companyInformation.hasOwnProperty("defaultDuration")) {
            roleObj.companyInformation.defaultDuration = "30";
          }
          this.setState({
            companyData: roleObj.companyInformation,
          });
        } else {
          this.setState({
            companyData: initialCompanyData,
          });
        }

        if (checkObjExists(this.props.profileData.dsd.settings)) {
          this.setState({
            autocompletesetting: this.props.profileData.dsd.settings,
          });
        } else {
          this.setState({
            autocompletesetting: initialSettingData,
          });
        }

        this.setState({
          dsdInfo: roleObj,
          roleShow: roleId,
        });
      } else {
        this.setState({
          dsdInfo: {},
          roleShow: "",
        });
      }
    }
  }

  /**
   * @desc set date to profile based on type
   * @param {*} type
   * @param {*} date
   */
  setDate(type, date) {
    if (type == "educationInfo") {
      this.setState({
        educationInfoDate: date.value,
      });
      $("#fromyear").val(date.value);
    }

    if (type == "educationInfo1") {
      this.setState({
        educationInfoDate1: date.value,
      });
      $("#toyear").val(date.value);
    }

    if (type == "certificationsInfo") {
      this.setState({
        certificationsInfoDate: moment(date).format("MM/DD/YYYY"),
      });
      $("#certDescription").val(moment(date).format("MM/DD/YYYY"));
    }

    if (type == "awardsInfo") {
      this.setState({
        awardsInfoDate: moment(date).format("MM/DD/YYYY"),
      });
      $("#awardsDescription").val(moment(date).format("MM/DD/YYYY"));
    }

    if (type == "userInfo") {
      this.setState({
        licenseExpDate: moment(date).format("MM/DD/YYYY"),
      });
    }
  }

  /**
   * @desc update profile data based on type
   * @param {*} type
   * @param {*} values
   */
  updateProfile(type, values) {
    this.uploadImage();
    this.uploadCompanyLogo();
    var values1 = values;
    this.setState({
      [type]: false,
    });

    if (type === "bioInfo") {
      values = this.props.profileData;
      if (values.dsd && values.dsd.roles && values.dsd.roles.length > 0) {
        let foundIndex = values.dsd.roles.findIndex(
          (x) => x.roleId == this.state.roleShow
        );
        values.dsd.roles[foundIndex].bio = values1.bio;
      } else {
        if (values.usertype === message.ACCTOWNER) {
          let accOwnerObj = {
            roleId: "ACCOWNER",
            roleName: "ACCOUNT OWNER",
            bio: values1.bio,
          };
          values.dsd = { roles: [] };
          values.dsd.roles.push(accOwnerObj);
        }
      }
    }

    if (type == "educationInfo") {
      values = this.props.profileData;
      if (this.state.educationEdit) {
        values.education[this.state.educationIndex].name = values1.name || "";
        values.education[this.state.educationIndex].description =
          this.state.educationInfoDate + "-" + this.state.educationInfoDate1 ||
          "";
      } else {
        values.education.push({
          name: values1.name || "",
          description:
            this.state.educationInfoDate +
              "-" +
              this.state.educationInfoDate1 || "",
        });
      }
    }

    if (type == "certificationsInfo") {
      values = this.props.profileData;
      if (this.state.certificationsEdit) {
        values.certifications[this.state.certificationsIndex].name =
          values1.name || "";
        values.certifications[this.state.certificationsIndex].description =
          values1.description || "";
      } else {
        values.certifications.push({
          name: values1.name || "",
          description: values1.description || "",
        });
      }
    }

    if (type == "awardsInfo") {
      values = this.props.profileData;
      if (this.state.awardsEdit) {
        values.awards[this.state.awardsIndex].name = values1.name || "";
        values.awards[this.state.awardsIndex].description =
          values1.description || "";
      } else {
        values.awards.push({
          name: values1.name || "",
          description: values1.description || "",
        });
      }
    }

    if (type == "goalInfo") {
      values = this.props.profileData;
      if (this.state.goalEdit) {
        values.goals[this.state.goalIndex].name = values1.name || "";
        values.goals[this.state.goalIndex].description =
          values1.description || "";
      } else {
        values.goals.push({
          name: values1.name || "",
          description: values1.description || "",
        });
      }
    }

    if (type === "availabilityInfo") {
      values = this.props.profileData;
      if (
        this.state.userType === message.VENDOR &&
        localStorage.getItem("vendorRoleName") === "Artist"
      ) {
        if (values.dsd && values.dsd.studios && values.dsd.studios.length > 0) {
          let foundIndex = values.dsd.studios.findIndex(
            (x) => x.ownerId == this.state.ownerId
          );
          if (foundIndex !== -1) {
            values.dsd.studios[foundIndex].availability = values1.availability
              ? values1.availability
              : "";
            values.dsd.studios[
              foundIndex
            ].includeWeekend = values1.includeWeekend
              ? values1.includeWeekend
              : false;
            values.dsd.studios[
              foundIndex
            ].includeUSHolidays = values1.includeUSHolidays
              ? values1.includeUSHolidays
              : false;
            values.dsd.studios[
              foundIndex
            ].defaultDuration = values1.defaultDuration
              ? values1.defaultDuration
              : "30";
          } else {
            let studioObj = {
              ownerId: this.state.ownerId,
              companyName: localStorage.getItem("companyName"),
              availability: values1.availability ? values1.availability : "",
              includeWeekend: values1.includeWeekend
                ? values1.includeWeekend
                : false,
              includeUSHolidays: values1.includeUSHolidays
                ? values1.includeUSHolidays
                : false,
              defaultDuration: values1.defaultDuration
                ? values1.defaultDuration
                : "30",
            };
            values.dsd.studios.push(studioObj);
          }
        } else {
          let studioObj = {
            ownerId: this.state.ownerId,
            companyName: localStorage.getItem("companyName"),
            availability: values1.availability ? values1.availability : "",
            includeWeekend: values1.includeWeekend
              ? values1.includeWeekend
              : false,
            includeUSHolidays: values1.includeUSHolidays
              ? values1.includeUSHolidays
              : false,
            defaultDuration: values1.defaultDuration
              ? values1.defaultDuration
              : "30",
          };
          values.dsd = { ...values.dsd, studios: [] };
          values.dsd.studios.push(studioObj);
        }
      } else {
        if (values.dsd && values.dsd.roles && values.dsd.roles.length > 0) {
          let foundIndex = values.dsd.roles.findIndex(
            (x) => x.roleId == this.state.roleShow
          );
          values.dsd.roles[foundIndex].availability = values1.availability
            ? values1.availability
            : "";
          values.dsd.roles[foundIndex].includeWeekend = values1.includeWeekend
            ? values1.includeWeekend
            : false;
          values.dsd.roles[
            foundIndex
          ].includeUSHolidays = values1.includeUSHolidays
            ? values1.includeUSHolidays
            : false;
          values.dsd.roles[foundIndex].defaultDuration = values1.defaultDuration
            ? values1.defaultDuration
            : "30";
        } else {
          if (values.usertype === message.ACCTOWNER) {
            let accOwnerObj = {
              roleId: "ACCOWNER",
              roleName: "ACCOUNT OWNER",
              availability: values1.availability ? values1.availability : "",
              includeWeekend: values1.includeWeekend
                ? values1.includeWeekend
                : false,
              includeUSHolidays: values1.includeUSHolidays
                ? values1.includeUSHolidays
                : false,
              defaultDuration: values1.defaultDuration
                ? values1.defaultDuration
                : "30",
            };
            values.dsd = { roles: [] };
            values.dsd.roles.push(accOwnerObj);
          }
        }
      }
    }

    if (type === "publicUrlInfo") {
      values = this.props.profileData;
      if (
        this.state.userType === message.VENDOR &&
        localStorage.getItem("vendorRoleName") === "Artist"
      ) {
        if (values.dsd && values.dsd.studios && values.dsd.studios.length > 0) {
          let foundIndex = values.dsd.studios.findIndex(
            (x) => x.ownerId === this.state.ownerId
          );
          if (foundIndex !== -1) {
            values.dsd.studios[foundIndex].publicUrl = values1.publicUrl
              ? values1.publicUrl
              : "";
            values.dsd.studios[
              foundIndex
            ].defaultBookingAmount = values1.defaultBookingAmount
              ? values1.defaultBookingAmount
              : "0";
          } else {
            let studioObj = {
              ownerId: this.state.ownerId,
              companyName: localStorage.getItem("companyName"),
              publicUrl: values1.publicUrl ? values1.publicUrl : "",
              defaultBookingAmount: values1.defaultBookingAmount
                ? values1.defaultBookingAmount
                : "0",
            };
            values.dsd.studios.push(studioObj);
          }
        } else {
          let studioObj = {
            ownerId: this.state.ownerId,
            companyName: localStorage.getItem("companyName"),
            publicUrl: values1.publicUrl ? values1.publicUrl : "",
            defaultBookingAmount: values1.defaultBookingAmount
              ? values1.defaultBookingAmount
              : "0",
          };
          values.dsd = { ...values.dsd, studios: [] };
          values.dsd.studios.push(studioObj);
        }
      } else {
        if (values.dsd && values.dsd.roles && values.dsd.roles.length > 0) {
          let foundIndex = values.dsd.roles.findIndex(
            (x) => x.roleId == this.state.roleShow
          );
          values.dsd.roles[foundIndex].publicUrl = values1.publicUrl
            ? values1.publicUrl
            : "";
          values.dsd.roles[
            foundIndex
          ].defaultBookingAmount = values1.defaultBookingAmount
            ? values1.defaultBookingAmount
            : "0";
          values.dsd.roles[
            foundIndex
          ].allowPublicProfile = values1.allowPublicProfile
            ? values1.allowPublicProfile
            : false;
          values.dsd.roles[
            foundIndex
          ].allowPublicScheduling = values1.allowPublicScheduling
            ? values1.allowPublicScheduling
            : false;
        } else {
          if (values.usertype === message.ACCTOWNER) {
            let accOwnerObj = {
              roleId: "ACCOWNER",
              roleName: "ACCOUNT OWNER",
              publicUrl: values1.publicUrl ? values1.publicUrl : "",
              defaultBookingAmount: values1.defaultBookingAmount
                ? values1.defaultbookingamount
                : "0",
              allowPublicProfile: values1.allowPublicProfile
                ? values1.allowPublicProfile
                : false,
              allowPublicScheduling: values1.allowPublicScheduling
                ? values1.allowPublicScheduling
                : false,
            };
            values.dsd = { roles: [] };
            values.dsd.roles.push(accOwnerObj);
          }
        }
      }
    }

    if (type === "dsd") {
      values = this.props.profileData;
      if (values.dsd && values.dsd.roles && values.dsd.roles.length > 0) {
        let foundIndex = values.dsd.roles.findIndex(
          (x) => x.roleId == this.state.roleShow
        );
        values.dsd.roles[foundIndex].brokerLicenseNo =
          values1.brokerLicenseNo || "";
        values.dsd.roles[foundIndex].licenseExpirationDate =
          values1.licenseExpirationDate === undefined
            ? moment().format("MM/DD/YYYY")
            : values1.licenseExpirationDate;
      } else {
        if (values.usertype === message.ACCTOWNER) {
          let accOwnerObj = {
            roleId: "ACCOWNER",
            roleName: "ACCOUNT OWNER",
            brokerLicenseNo: values1.brokerLicenseNo || "",
            licenseExpirationDate:
              values1.licenseExpirationDate === undefined
                ? moment().format("MM/DD/YYYY")
                : values1.licenseExpirationDate,
          };
          values.dsd = { roles: [] };
          values.dsd.roles.push(accOwnerObj);
        }
      }
    }

    if (type === "transactionAutoComplete") {
      values = this.props.profileData;
      values.dsd = { ...values.dsd, settings: values1 };
    }
    if (type === "companyInfo") {
      values = this.props.profileData;
      if (values.dsd && values.dsd.roles && values.dsd.roles.length > 0) {
        let foundIndex = values.dsd.roles.findIndex(
          (x) => x.roleId == this.state.roleShow
        );
        values.dsd.roles[foundIndex].companyInformation = values1;
      } else {
        if (values.usertype === message.ACCTOWNER) {
          let accOwnerObj = {
            roleId: "ACCOWNER",
            roleName: "ACCOUNT OWNER",
            companyInformation: values1,
          };
          values.dsd = { roles: [] };
          values.dsd.roles.push(accOwnerObj);
        }
      }
    }
    var dataToSend = {
      email: {
        address: values.email ? values.email.address || "" : "",
      },
      socialMediaHandles: {
        facebook: values.socialMediaHandles
          ? values.socialMediaHandles.facebook
          : "",
        instagram: "www.instagram.com/admin",
      },
      education: values.education,
      certifications: values.certifications,
      awards: values.awards,
      goals: values.goals,
      firstname: values.firstname || "",
      lastname: values.lastname || "",
      mobileNumber: values.mobileNumber || "",
      otherNumber: values.otherNumber || "",
      // knowAboutUs: "Advertisement",
      // address: values.address,
      // bio: values.bio,
      // jobTitle: values.jobTitle || "",
      // quote: values.quote || "",
      avatar: values.avatar || "-",

      dsd: values.dsd || "",
    };

    this.setState({
      showLoader: true,
    });

    if (this.props.match.params.id) {
      let userID = this.props.match.params.id;
      this.props.updateUserProfileAction(dataToSend, userID).then((res) => {
        this.props.myProfileAction(userID).then(
          (res) => {
            this.setState({
              showLoader: false,
              brokerageInfo: false,
              dsdInfoPrompt: false,
            });
          },
          (error) => {
            this.setState({
              showLoader: false,
            });
          }
        );
      });
    } else {
      this.props.updateProfileAction(dataToSend).then((res) => {
        this.props.myProfileAction().then(
          (res) => {
            this.setState({
              showLoader: false,
              brokerageInfo: false,
              dsdInfoPrompt: false,
              autocompletesettingmodel: false,
            });
          },
          (error) => {
            this.setState({
              showLoader: false,
            });
          }
        );
      });
    }
  }

  // user Info modal
  userModal() {
    this.setState({ userInfo: !this.state.userInfo, selectedImage: "" });
  }

  // bio Info modal
  bioModal() {
    this.setState({ bioInfo: !this.state.bioInfo });
  }

  // Goal Info modal
  goalModal(type, index) {
    this.setState({
      goalInfo: !this.state.goalInfo,
      goalEdit: type == "edit" ? true : false,
      goalData: type == "edit" ? this.props.profileData.goals[index] : {},
      goalIndex: index,
    });
  }

  // education Info modal
  educationModal(type, index) {
    this.setState({
      educationInfo: !this.state.educationInfo,
      educationEdit: type == "edit" ? true : false,
      educationData:
        type == "edit" ? this.props.profileData.education[index] : {},
      educationIndex: index,
      educationInfoDate:
        type == "edit"
          ? this.props.profileData.education[index].description
            ? this.props.profileData.education[index].description.split("-")[0]
            : ""
          : "",
      educationInfoDate1:
        type == "edit"
          ? this.props.profileData.education[index].description
            ? this.props.profileData.education[index].description.split("-")[0]
            : ""
          : "",
    });
  }

  // certifications Info modal
  certificationsModal(type, index) {
    setTimeout(function() {
      $(".modal-tabindex").removeAttr("tabindex");
    }, 100);

    this.setState({
      certificationsInfo: !this.state.certificationsInfo,
      certificationsEdit: type == "edit" ? true : false,
      certificationsData:
        type == "edit" ? this.props.profileData.certifications[index] : {},
      certificationsIndex: index,
    });
  }

  // awards Info modal
  awardsModal(type, index) {
    setTimeout(function() {
      $(".modal-tabindex").removeAttr("tabindex");
    }, 100);

    this.setState({
      awardsInfo: !this.state.awardsInfo,
      awardsEdit: type == "edit" ? true : false,
      awardsData: type == "edit" ? this.props.profileData.awards[index] : {},
      awardsIndex: index,
    });
  }

  // awards Info modal
  signatureModal(type, index) {
    setTimeout(function() {
      $(".modal-tabindex").removeAttr("tabindex");
    }, 100);

    this.setState({
      signatureInfo: !this.state.signatureInfo,
    });
  }

  availabilityModal(type, index) {
    setTimeout(function() {
      $(".modal-tabindex").removeAttr("tabindex");
    }, 100);

    this.setState({
      availabilityInfo: !this.state.availabilityInfo,
    });
  }

  artistPublicUrlInfoModal() {
    this.setState({
      artistPublicUrlInfo: !this.state.artistPublicUrlInfo,
    });
  }

  // company Info modal
  companyModal() {
    this.setState({
      companyInfo: !this.state.companyInfo,
      selectedCompanyLogo: "",
    });
  }

  /**
   * @desc open delete promt
   * @param {*} type
   * @param {*} index
   */
  deletePrompt(type, index) {
    if (type) {
      this.setState({
        deletePrompt: !this.state.deletePrompt,
        deleteType: type,
        deleteIndex: index,
      });
    } else {
      this.setState({
        deletePrompt: !this.state.deletePrompt,
      });
    }
  }

  /**
   * @desc on confirm delete action call api for updating profile data
   * @param {*} type
   * @param {*} index
   */
  confirmDelete(type, index) {
    var dataToSend = this.props.profileData;
    dataToSend[type].splice(index, 1);
    this.setState({
      showLoader: true,
    });
    this.props.updateProfileAction(dataToSend).then((res) => {
      this.props.myProfileAction().then(
        (res) => {
          this.setState(
            {
              deletePrompt: !this.state.deletePrompt,
              showLoader: false,
            },
            (error) => {
              this.setState({
                showLoader: false,
              });
            }
          );
        },
        (error) => {
          this.setState({
            showLoader: false,
          });
        }
      );
    });
  }

  goBack() {
    window.history.back();
  }

  setMobile(value, field, setFieldValue) {
    var mob = value.replace(/-/g, "");
    setFieldValue(field, mob);
  }

  // company Info modal
  brokerageModal() {
    this.setState({ brokerageInfo: !this.state.brokerageInfo });
  }
  uploadImage() {
    var formData = new FormData();
    formData.append("file", this.state.profileImage);
    if (this.state.profileImage !== "") {
      formData.showSuccessMessage = false;
      APIUtil.postFormDataMethod(
        UrlConstants.uploadAvatarUrl,
        formData,
        true
      ).then((res) => {
        if (res) {
          this.setState({ profileImage: "" });
        }
      });
    }
  }

  uploadCompanyLogo() {
    var formData = new FormData();
    formData.append("file", this.state.companyLogo);
    if (this.state.companyLogo !== "") {
      formData.showSuccessMessage = false;
      APIUtil.postFormDataMethod(
        UrlConstants.uploadAvatarUrl,
        formData,
        true
      ).then((res) => {
        if (res) {
          this.setState({ companyLogo: "" });
        }
      });
    }
  }

  dsdInfoModal() {
    this.setState({ dsdInfoPrompt: !this.state.dsdInfoPrompt });
  }

  autoComplitionsettingModel() {
    this.setState({
      autocompletesettingmodel: !this.state.autocompletesettingmodel,
    });
  }

  billingSettingModal() {
    this.setState({
      billingSettingModal: !this.state.billingSettingModal,
    });
  }

  campaignDefaultSettingModal() {
    this.setState({
      campaignDefaultSettingPrompt: !this.state.campaignDefaultSettingPrompt,
    });
  }

  loadUserCampaigns(id) {
    this.props.getUserCampaignsAction(id).then((res) => {
      let resData = res.data.data;
      for (let i = 0, len = resData.length; i < len; i++) {
        let camp = resData[i];
        if (camp.default) {
          let campObj = {
            id: camp._id,
            name: camp.name,
          };

          this.setState({
            campaignDefaultSetting: campObj,
          });
        }
      }

      this.setState({
        userCampaigns: resData || [],
      });
    });
  }

  updateCampaignDefault(values) {
    let data = {
      id: values.id,
    };
    this.props.updateUserCampaignDefaultAction(data).then((res) => {
      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, message.USER_CAMPAIGN_DEFAULT_SUCCESS);
        this.loadUserCampaigns();
        this.campaignDefaultSettingModal();
      } else {
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        this.campaignDefaultSettingModal();
      }
    });
  }

  pathwayDefaultSettingModal() {
    this.setState({
      pathwayDefaultSettingPrompt: !this.state.pathwayDefaultSettingPrompt,
    });
  }

  loadUserPathways(id) {
    this.props.getUserPathwaysAction(id).then((res) => {
      let resData = res.data.data;
      for (let i = 0, len = resData.length; i < len; i++) {
        let pathway = resData[i];
        if (pathway.default) {
          let pthObj = {
            id: pathway._id,
            name: pathway.name,
          };

          this.setState({
            pathwayDefaultSetting: pthObj,
          });
        }
      }

      this.setState({
        userPathways: resData || [],
      });
    });
  }

  updatePathwayDefault(values) {
    let data = {
      id: values.id,
    };
    this.props.updateUserPathwayDefaultAction(data).then((res) => {
      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, message.USER_PATHWAY_DEFAULT_SUCCESS);
        this.loadUserPathways();
        this.pathwayDefaultSettingModal();
      } else {
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        this.pathwayDefaultSettingModal();
      }
    });
  }
  loadUserTransPaymentDetails(id) {
    this.props.getUserTransPaymentAction(id).then((res) => {
      let data = {
        mid: (res && res.data && res.data.mid) || "",
        developerKey: (res && res.data && res.data.developerKey) || "",
        apiPassword: (res && res.data && res.data.password) || "",
        invoicePrefix:
          (res && res.data && res.data.invoicePrefix) || randomCapitalString(),
        billingSettingStatus:
          (res && res.data && res.data.isCardProcessEnabled) || false,
        serviceFeeEnabled:
          (res && res.data && res.data.serviceFeeEnabled) || false,
        appSource: (res && res.data && res.data.appSource) || "",
      };
      this.setState({
        billingSettingData: data,
      });
    });
  }

  updateUserBillingSetting(values) {
    let data = {
      mid: values.mid.trim(),
      developerKey: values.developerKey.trim(),
      password: values.apiPassword.trim(),
      isCardProcessEnabled: values.billingSettingStatus,
      invoicePrefix: values.invoicePrefix.trim(),
      serviceFeeEnabled: values.serviceFeeEnabled,
      appSource: values.appSource.trim(),
    };
    this.props.updateUserTransPaymentAction(data).then((res) => {
      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, message.TRANSACTION_PAYMENT_UPDATE);
        this.loadUserTransPaymentDetails();
        this.billingSettingModal();
      } else {
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        this.billingSettingModal();
      }
    });
  }

  getArtistProfileUrl() {
    return checkObjExists(this.state.dsdInfo) &&
      this.state.dsdInfo.publicUrl &&
      this.state.dsdInfo.publicUrl !== undefined &&
      this.state.dsdInfo.publicUrl !== null &&
      this.state.artistPublicUrlInfoExists
      ? UrlConstants.artistPublicProfileUrl + this.state.dsdInfo.publicUrl
      : "";
  }

  getStudioProfileUrl() {
    return checkObjExists(this.state.companyData) &&
      this.state.companyData.publicUrl &&
      this.state.companyData.publicUrl !== undefined &&
      this.state.companyData.publicUrl !== null
      ? UrlConstants.publicProfileUrl + this.state.companyData.publicUrl
      : "";
  }

  /**
   * @desc render for admin profile
   */
  adminRender() {
    var user = this.props.profileData || {};

    return (
      <div className="change-pass change-pass-profile">
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <div className="change-pass-inner">
          <Formik
            validateOnBlur={true}
            initialValues={user}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              firstname: Yup.string()
                .trim()
                .required(message.ENTER_FIRST_NAME)
                .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                  message: message.ENTER_VALID_FIRST_NAME,
                }),
              lastname: Yup.string()
                .trim()
                .required(message.ENTER_LAST_NAME)
                .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                  message: message.ENTER_VALID_LAST_NAME,
                }),
              otherNumber: Yup.string()
                .nullable()
                .test(
                  "otherNumber",
                  "Please enter valid phone number",
                  (value) => {
                    if (value == undefined || value == "") {
                      return true;
                    } else {
                      if (value.length == 10) {
                        return true;
                      }
                    }
                    return false;
                  }
                ),
              mobileNumber: Yup.string()
                .nullable()
                .required(message.ENTER_MOBILE_NUMBER)
                .test("mobileNumber", message.ENTER_VALID_MOBILE, (value) => {
                  if ((value || "").length === 10 && value.charAt(0) != "0") {
                    return true;
                  }
                  return false;
                })
                .test(
                  "mobileNumber",
                  message.MOBILE_NUMBER_EXISTS, // <- key, message
                  (value) => {
                    return new Promise((resolve, reject) => {
                      if ((value || "").length === 10) {
                        let data = value.replace(/-/g, "");
                        APIUtil.getMethod(
                          UrlConstants.addContact +
                            "/CheckEmailOrMobileUniqueatregistration?mobile=" +
                            data,
                          false
                        )
                          .then((response) => {
                            if (
                              response &&
                              response.data &&
                              response.data.error === "Unauthorized" &&
                              response.data.data.mobile === 1 &&
                              response.data.data._id !==
                                localStorage.getItem("ID")
                            ) {
                              resolve(false);
                            } else {
                              resolve(true);
                            }
                          })
                          .catch((error) => {
                            resolve(true);
                          });
                      } else {
                        resolve(true);
                      }
                    });
                  }
                ),
            })}
            onSubmit={(values) => {
              this.updateProfile("userInfo", values);
            }}
          >
            {({ values, setFieldValue }) => (
              <Form className="form-sm form-admin">
                <Row>
                  <Col xs="12">
                    <div className="profile-img profile-img-big">
                      <img
                        src={
                          this.state.selectedImage
                            ? this.state.selectedImage
                            : this.props.profileData.avatar &&
                              this.props.profileData.avatar !== "-"
                            ? UrlConstants.AdminCreateTransactionUrl +
                              "/upload?id=" +
                              this.props.profileData._id +
                              "&img=" +
                              this.props.profileData.avatar
                            : UserImage
                        }
                        alt="user"
                        style={{ flex: 1, height: "100%", width: undefined }}
                        resizeMode="contain"
                      />
                    </div>
                    <div className="text-center">
                      <label
                        htmlFor="userImg"
                        className="color-blue-4 font-500"
                      >
                        Edit
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        id="userImg"
                        style={{ opacity: "0", position: "absolute" }}
                        onChange={(e) => {
                          setFieldValue("avatar", e.target.files[0].name);
                          this.setState({
                            selectedImage: URL.createObjectURL(
                              e.target.files[0]
                            ),
                            profileImage: e.target.files[0],
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label className="control-label">Username</label>
                      <Field
                        type="text"
                        value={values.userName ? values.userName : ""}
                        disabled
                        className="form-control"
                        name="username"
                      />
                    </div>
                  </Col>

                  {user &&
                    user.billingUserData &&
                    this.state.accOwnerBuyerAgentFlag && (
                      <Col className="col-auto mb-1">
                        <div className="font-14 color-grey-1 font-500">
                          Current Credit:
                        </div>
                        <div>
                          ${" "}
                          {user.billingUserData.currentCredit > 0
                            ? user.billingUserData.currentCredit.toFixed(2)
                            : "0.00"}
                        </div>
                      </Col>
                    )}
                </Row>

                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label className="control-label">
                        First Name<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        value={values.firstname}
                        className="form-control field_ucfirst"
                        name="firstname"
                      />
                      <ErrorMessage
                        name="firstname"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label className="control-label">
                        Last Name<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        value={values.lastname}
                        className="form-control field_ucfirst"
                        name="lastname"
                      />
                      <ErrorMessage
                        name="lastname"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <div className="form-group">
                      <label className="control-label">Email</label>
                      <Field
                        type="email"
                        value={values.email ? values.email.address : ""}
                        disabled
                        className="form-control"
                        name="email.address"
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label className="control-label">Phone (Office)</label>
                      <InputMask
                        mask="999-999-9999"
                        maskChar=""
                        formControlProps={{
                          fullWidth: true,
                        }}
                        value={values.otherNumber}
                        name="otherNumber"
                        className="form-control"
                        onChange={(e) => {
                          this.setMobile(
                            e.target.value,
                            "otherNumber",
                            setFieldValue
                          );
                        }}
                      >
                        {(inputProps) => <Field {...inputProps} />}
                      </InputMask>
                      <ErrorMessage
                        name="otherNumber"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label className="control-label">
                        Mobile Number<span className="text-danger"> *</span>
                      </label>
                      <InputMask
                        mask="999-999-9999"
                        maskChar=""
                        formControlProps={{
                          fullWidth: true,
                        }}
                        className="form-control"
                        value={values.mobileNumber}
                        name="mobileNumber"
                        onChange={(e) => {
                          this.setMobile(
                            e.target.value,
                            "mobileNumber",
                            setFieldValue
                          );
                        }}
                      >
                        {(inputProps) => <Field {...inputProps} />}
                      </InputMask>
                      <ErrorMessage
                        name="mobileNumber"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Button
                      variant="primary"
                      type="submit"
                      size="sm"
                      className="btn-blue w-140"
                    >
                      Update
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  }

  /**
   * @desc render for agent/buyer/vendor profile
   */
  agentRender() {
    var stateDropDownValue = [];
    for (var key in StatesList) {
      var opt = (
        <option key={key} value={key}>
          {StatesList[key]}
        </option>
      );
      stateDropDownValue.push(opt);
    }

    const options = [];
    for (let index = 0; index < 50; index++) {
      options.push({
        label: moment()
          .subtract("years", index)
          .year(),
        value: moment()
          .subtract("years", index)
          .year(),
      });
    }

    const options1 = options.filter((e) => {
      return e.value >= this.state.educationInfoDate;
    });

    var user = this.props.profileData || {};

    var roleInfo =
      this.state.userType === message.VENDOR &&
      localStorage.getItem("vendorRoleName") === "Artist"
        ? this.state.artistDsdRoleInfo
        : this.state.dsdInfo;
    var aboutMeText =
      checkObjExists(roleInfo) && roleInfo.bio
        ? roleInfo.bio.length > 200
          ? roleInfo.bio.slice(0, 200) + "..."
          : roleInfo.bio
        : "-";

    var companyAddress = "-";

    if (!!this.state.companyData && this.state.companyData !== undefined) {
      if (
        !!this.state.companyData.address &&
        !!this.state.companyData.city &&
        !!this.state.companyData.state &&
        !!this.state.companyData.zipcode
      ) {
        companyAddress = ReactHtmlParser(
          this.state.companyData.address +
            ", " +
            this.state.companyData.city +
            ", <br>" +
            this.state.companyData.state +
            " " +
            this.state.companyData.zipcode
        );
      }
    }

    if (!!user.socialMediaHandles) {
      if (user.socialMediaHandles.zillow === undefined) {
        user.socialMediaHandles.zillow = "";
      }
      if (user.socialMediaHandles.realtor === undefined) {
        user.socialMediaHandles.realtor = "";
      }
    }

    let userID = "";
    if (this.props.match.params.id) {
      userID = this.props.match.params.id;
    }

    return (
      <div className="profile-page">
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <Row className="mx-0 profile-basic-info">
          <Col xs="12" align="right">
            <Button
              variant="transparent"
              className="close-big p-0"
              onClick={() => {
                this.goBack();
              }}
            >
              <Close />
            </Button>
          </Col>
          <Col className="col-auto">
            <div className="profile-left">
              <div className="profile-img">
                <img
                  src={
                    this.props.profileData.avatar &&
                    this.props.profileData.avatar !== "-"
                      ? UrlConstants.AdminCreateTransactionUrl +
                        "/upload?id=" +
                        this.props.profileData._id +
                        "&img=" +
                        this.props.profileData.avatar
                      : UserImage
                  }
                  alt="user"
                />
              </div>
            </div>
          </Col>
          <Col>
            <div>
              <h4 className="font-24" style={{ textTransform: "capitalize" }}>
                {user.firstname} {user.lastname}
                {this.state.onlyViewMode ? (
                  ""
                ) : (
                  <Button
                    variant="transparent"
                    className="edit-icn p-0"
                    onClick={() => this.userModal()}
                  >
                    <Edit />
                  </Button>
                )}
              </h4>
            </div>

            <Row>
              {((this.state.userType == message.ACCTOWNER && userID == "") ||
                this.state.userData.usertype == message.ACCTOWNER) && (
                <Col className="col-auto pr-5 mb-1">
                  <div className="font-14 color-grey-1 font-500">
                    License Number:
                    {this.state.onlyViewMode ? (
                      ""
                    ) : (
                      <Button
                        variant="transparent"
                        className="edit-icn p-0"
                        onClick={() => this.dsdInfoModal()}
                      >
                        <Edit />
                      </Button>
                    )}
                  </div>
                  <div>
                    {checkObjExists(this.state.dsdInfo) &&
                    this.state.dsdInfo.brokerLicenseNo
                      ? this.state.dsdInfo.brokerLicenseNo
                      : ""}
                  </div>
                  <div className="font-12">
                    Expire on{" "}
                    {checkObjExists(this.state.dsdInfo) &&
                    this.state.dsdInfo.licenseExpirationDate
                      ? this.state.dsdInfo.licenseExpirationDate
                      : ""}
                  </div>
                </Col>
              )}

              {user.otherNumber != "" && user.otherNumber != null && (
                <Col className="col-auto mb-1">
                  <div className="font-14 color-grey-1 font-500">
                    Phone (Office):
                  </div>

                  <div>
                    {!!user.otherNumber ? (
                      <a
                        style={{ color: "black" }}
                        href={"tele:" + user.otherNumber}
                      >
                        <PhoneNumber phoneNumber={user.otherNumber} />
                      </a>
                    ) : (
                      <PhoneNumber phoneNumber={user.otherNumber} />
                    )}
                  </div>
                </Col>
              )}

              <Col className="col-auto mb-1">
                <div className="font-14 color-grey-1 font-500">
                  Phone (Mobile):
                </div>
                <div>
                  {!!user.mobileNumber ? (
                    <a
                      style={{ color: "black" }}
                      href={"tele:" + user.mobileNumber}
                    >
                      <PhoneNumber phoneNumber={user.mobileNumber} />
                    </a>
                  ) : (
                    <PhoneNumber phoneNumber={user.mobileNumber} />
                  )}
                </div>
              </Col>
              {user.email && (
                <Col className="col-auto mb-1">
                  <div className="font-14 color-grey-1 font-500">Email:</div>
                  <div className="email-case">
                    <a
                      style={{ color: "black" }}
                      href={"mailto:" + user.email.address}
                    >
                      {user.email.address}
                    </a>
                  </div>
                </Col>
              )}
              {user && user.userName && (
                <Col className="col-auto mb-1">
                  <div className="font-14 color-grey-1 font-500">Username:</div>
                  <div>{user.userName}</div>
                </Col>
              )}
              {user && user.billingUserData && (
                <Col className="col-auto mb-1">
                  <div className="font-14 color-grey-1 font-500">
                    Current Credit:
                  </div>
                  <div>
                    ${" "}
                    {user.billingUserData.currentCredit > 0
                      ? user.billingUserData.currentCredit.toFixed(2)
                      : "0.00"}
                  </div>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        <Row className="mx-0">
          <Col className="col-auto hide-767">
            <div className="profile-left" />
          </Col>
          {this.state.userType === message.VENDOR &&
          localStorage.getItem("vendorRoleName") === "Client" ? (
            <>
              <Col xs="12" sm="4">
                <div className="mt-3 profile-block">
                  <h5 className="font-20 color-blue-4 font-600">
                    Upload Personal Documents
                  </h5>
                  {this.state.onlyViewMode ? (
                    ""
                  ) : (
                    <Button
                      variant="transparent"
                      className="edit-icn p-0"
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/uploadPersonalDocuments",
                          state: {
                            id: localStorage.getItem("ID"),
                            fullName: "My",
                          },
                        });
                      }}
                    >
                      <Edit />
                    </Button>
                  )}
                </div>
              </Col>
            </>
          ) : (
            <>
              <Col xs="12" sm="4">
                <div className="mt-3 profile-block">
                  {this.state.onlyViewMode ||
                  (this.state.userType === message.VENDOR &&
                    localStorage.getItem("vendorRoleName") === "Artist") ? (
                    ""
                  ) : (
                    <Button
                      variant="transparent"
                      className="edit-icn p-0"
                      onClick={() => this.companyModal()}
                    >
                      <Edit />
                    </Button>
                  )}
                  <h5 className="font-20 color-blue-4 font-600">
                    Studio Information:
                  </h5>

                  <div className="mb-4">
                    <h6 className="mb-1">
                      {this.state.companyData && this.state.companyData.name
                        ? this.state.companyData.name || "-"
                        : "-"}
                    </h6>
                    <p
                      className="color-grey-1 font-500 font-14"
                      style={{ lineHeight: "20px" }}
                    >
                      {companyAddress}
                    </p>
                  </div>

                  <div className="mb-4">
                    <h6 className="color-grey-1 font-500 font-14 mb-1">
                      Phone (Office):
                    </h6>
                    <p>
                      {!!this.state.companyData &&
                      !!this.state.companyData.phoneNumber ? (
                        <a
                          style={{ color: "black" }}
                          href={"tele:" + this.state.companyData.phoneNumber}
                        >
                          <PhoneNumber
                            phoneNumber={this.state.companyData.phoneNumber}
                          />
                        </a>
                      ) : (
                        "-"
                      )}
                    </p>
                  </div>

                  <div className="mb-4">
                    <h6 className="color-grey-1 font-500 font-14 mb-1">
                      Website:
                    </h6>
                    <p>
                      {this.state.companyData
                        ? this.state.companyData.website || "-"
                        : "-"}
                    </p>
                  </div>
                </div>

                <div className="mt-3 profile-block">
                  {this.state.onlyViewMode ? (
                    ""
                  ) : (
                    <Button
                      variant="transparent"
                      className="edit-icn p-0"
                      onClick={() => this.bioModal()}
                    >
                      <Edit />
                    </Button>
                  )}
                  <h5 className="font-20 color-blue-4 font-600">About Me</h5>
                  <div className="color-grey-1 font-14">
                    {ReactHtmlParser(aboutMeText)}
                  </div>
                </div>

                <div className="mt-2 profile-block profile-block-multi sign-block">
                  <Row>
                    <Col className="col-auto pr-0">
                      <h5 className="font-20 color-blue-4 font-600">
                        Availability
                      </h5>
                    </Col>
                    <Col>
                      {this.state.onlyViewMode ? (
                        ""
                      ) : (
                        <>
                          {checkObjExists(this.state.dsdInfo) &&
                          this.state.dsdInfo.availability !== undefined &&
                          this.state.dsdInfo.availability !== null &&
                          this.state.dsdInfo.availability !== "" ? (
                            <Button
                              variant="transparent"
                              className="edit-icn p-0"
                              onClick={() => this.availabilityModal("edit")}
                            >
                              <Edit />
                            </Button>
                          ) : (
                            <Button
                              variant="transparent"
                              className="p-0 add-btn"
                              onClick={() => this.availabilityModal("add")}
                            >
                              <Add />
                            </Button>
                          )}
                        </>
                      )}
                    </Col>
                  </Row>
                  <div className="color-grey-1 font-14">
                    {ReactHtmlParser(
                      checkObjExists(this.state.dsdInfo) &&
                        this.state.dsdInfo.availability
                        ? this.state.dsdInfo.availability.replace(
                            /(?:\r\n|\r|\n)/g,
                            "<br>"
                          )
                        : ""
                    )}
                  </div>
                </div>

                <div className="mt-2 profile-block profile-block-multi sign-block">
                  <Row>
                    <Col className="col-auto pr-0">
                      <h5 className="font-20 color-blue-4 font-600">
                        Public Profile URL
                      </h5>
                    </Col>
                    <Col>
                      {this.getArtistProfileUrl() ? (
                        <>
                          {!this.state.onlyViewMode && (
                            <Button
                              variant="transparent"
                              className="edit-icn p-0"
                              onClick={() =>
                                this.artistPublicUrlInfoModal("edit")
                              }
                              style={{ marginRight: "30px" }}
                            >
                              <Edit />
                            </Button>
                          )}

                          <Button
                            variant="transparent"
                            className="edit-icn p-0"
                            onClick={() => {
                              navigator.clipboard.writeText(
                                this.getArtistProfileUrl()
                              );
                              document.getElementById(
                                "custom-tooltip"
                              ).style.display = "inline";
                              setTimeout(function() {
                                document.getElementById(
                                  "custom-tooltip"
                                ).style.display = "none";
                              }, 1000);
                            }}
                          >
                            <ContentCopy />
                          </Button>
                          <span id="custom-tooltip">Copied!</span>
                        </>
                      ) : !this.state.onlyViewMode ? (
                        <Button
                          variant="transparent"
                          className="p-0 add-btn"
                          onClick={() => this.artistPublicUrlInfoModal("add")}
                        >
                          <Add />
                        </Button>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                  <div
                    className="color-grey-1 font-14"
                    onClick={() => {
                      window.open(this.getArtistProfileUrl(), "_blank");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {ReactHtmlParser(this.getArtistProfileUrl())}
                  </div>
                </div>

                {((this.state.userType == message.ACCTOWNER && userID == "") ||
                  this.state.userData.usertype == message.ACCTOWNER) && (
                  <>
                    <div className="mt-3 profile-block">
                      <h5 className="font-20 color-blue-4 font-600">
                        Card Process Billing Settings:{" "}
                        {this.state.billingSettingData.billingSettingStatus ? (
                          <span style={{ color: "green" }}>ON</span>
                        ) : (
                          <span style={{ color: "red" }}>OFF</span>
                        )}
                      </h5>
                      {this.state.onlyViewMode ? (
                        ""
                      ) : (
                        <Button
                          variant="transparent"
                          className="edit-icn p-0"
                          onClick={() => this.billingSettingModal()}
                        >
                          <Edit />
                        </Button>
                      )}
                    </div>
                  </>
                )}

                {this.state.onlyViewMode &&
                  user &&
                  user.usertype === message.ACCTOWNER && (
                    <>
                      <div className="mt-3 profile-block">
                        <h5 className="font-20 color-blue-4 font-600">
                          Plan Name
                        </h5>
                        <div className="color-grey-1 font-14">
                          {ReactHtmlParser(
                            user &&
                              user.billingUserData &&
                              user.billingUserData.PlanName
                              ? user.billingUserData.PlanName
                              : "-"
                          )}
                        </div>
                      </div>
                    </>
                  )}
                {this.state.onlyViewMode &&
                  user &&
                  user.usertype === message.ACCTOWNER && (
                    <>
                      <div className="mt-3 profile-block">
                        <h5 className="font-20 color-blue-4 font-600">
                          Plan Start Date
                        </h5>
                        <div className="color-grey-1 font-14">
                          {ReactHtmlParser(
                            user &&
                              user.billingUserData &&
                              user.billingUserData.currentPlanStartDate
                              ? moment(
                                  user.billingUserData.currentPlanStartDate
                                ).format("MM/DD/YYYY")
                              : "-"
                          )}
                        </div>
                      </div>
                    </>
                  )}
                {this.state.onlyViewMode &&
                  user &&
                  user.usertype === message.ACCTOWNER && (
                    <>
                      <div className="mt-3 profile-block">
                        <h5 className="font-20 color-blue-4 font-600">
                          Plan End Date
                        </h5>
                        <div className="color-grey-1 font-14">
                          {ReactHtmlParser(
                            user &&
                              user.billingUserData &&
                              user.billingUserData.currentPlanEndDate
                              ? moment(
                                  user.billingUserData.currentPlanEndDate
                                ).format("MM/DD/YYYY")
                              : "-"
                          )}
                        </div>
                      </div>
                    </>
                  )}
              </Col>

              <Col xs="12" sm="4">
                {((this.state.userType == message.ACCTOWNER && userID == "") ||
                  this.state.userData.usertype == message.ACCTOWNER) && (
                  <>
                    <div className="mt-3 profile-block">
                      <h5 className="font-20 color-blue-4 font-600">
                        Autocomplete Transaction:{" "}
                        {this.state.autocompletesetting
                          .autoCompleteTransactions ? (
                          <span style={{ color: "green" }}>ON</span>
                        ) : (
                          <span style={{ color: "red" }}>OFF</span>
                        )}
                      </h5>
                      {this.state.onlyViewMode ? (
                        ""
                      ) : (
                        <Button
                          variant="transparent"
                          className="edit-icn p-0"
                          onClick={() => this.autoComplitionsettingModel()}
                        >
                          <Edit />
                        </Button>
                      )}
                    </div>
                    <div className="mt-3 profile-block">
                      <h5 className="font-20 color-blue-4 font-600">
                        Artwork Settings
                      </h5>
                      <div className="mt-3 profile-block">
                        <h6 className="font-16 color-blue-4 font-600">
                          Default Campaign:
                        </h6>
                        <div className="mb-4">
                          <h6 className="mb-1">
                            {this.state.campaignDefaultSetting &&
                            this.state.campaignDefaultSetting.name
                              ? this.state.campaignDefaultSetting.name
                              : "-"}
                          </h6>
                        </div>
                        {this.state.onlyViewMode ? (
                          ""
                        ) : (
                          <Button
                            variant="transparent"
                            className="edit-icn p-0"
                            onClick={() => this.campaignDefaultSettingModal()}
                          >
                            <Edit />
                          </Button>
                        )}
                      </div>
                      <div className="mt-3 profile-block">
                        <h6 className="font-16 color-blue-4 font-600">
                          Default Pathway:
                        </h6>
                        <div className="mb-4">
                          <h6 className="mb-1">
                            {this.state.pathwayDefaultSetting &&
                            this.state.pathwayDefaultSetting.name
                              ? this.state.pathwayDefaultSetting.name
                              : "-"}
                          </h6>
                        </div>
                        {this.state.onlyViewMode ? (
                          ""
                        ) : (
                          <Button
                            variant="transparent"
                            className="edit-icn p-0"
                            onClick={() => this.pathwayDefaultSettingModal()}
                          >
                            <Edit />
                          </Button>
                        )}
                      </div>
                    </div>
                  </>
                )}
                <div className="mt-3 profile-block">
                  <h5 className="font-20 color-blue-4 font-600">
                    Upload Personal Documents
                  </h5>
                  {this.state.onlyViewMode ? (
                    ""
                  ) : (
                    <Button
                      variant="transparent"
                      className="edit-icn p-0"
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/uploadPersonalDocuments",
                          state: {
                            id: localStorage.getItem("ID"),
                            fullName: "My",
                          },
                        });
                      }}
                    >
                      <Edit />
                    </Button>
                  )}
                </div>
              </Col>
            </>
          )}
        </Row>

        <Modal
          show={this.state.userInfo}
          onHide={() => this.userModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Edit Personal Information
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={user}
              enableReinitialize={true}
              validationSchema={Yup.object().shape({
                firstname: Yup.string()
                  .trim()
                  .required(message.ENTER_FIRST_NAME)
                  .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                    message: message.ENTER_VALID_FIRST_NAME,
                  }),
                lastname: Yup.string()
                  .trim()
                  .required(message.ENTER_LAST_NAME)
                  .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                    message: message.ENTER_VALID_LAST_NAME,
                  }),
                otherNumber: Yup.string()
                  .nullable()
                  .test(
                    "otherNumber",
                    "Please enter valid phone number",
                    (value) => {
                      if (value == undefined || value == "") {
                        return true;
                      } else {
                        if (value.length == 10) {
                          return true;
                        }
                      }
                      return false;
                    }
                  ),
                mobileNumber: Yup.string()
                  .required(message.ENTER_MOBILE_NUMBER)
                  .test("mobileNumber", message.ENTER_VALID_MOBILE, (value) => {
                    if ((value || "").length === 10 && value.charAt(0) != "0") {
                      return true;
                    }
                    return false;
                  })
                  .test(
                    "mobileNumber",
                    message.MOBILE_NUMBER_EXISTS, // <- key, message
                    (value) => {
                      return new Promise((resolve, reject) => {
                        if ((value || "").length === 10) {
                          let data = value.replace(/-/g, "");
                          APIUtil.getMethod(
                            UrlConstants.addContact +
                              "/CheckEmailOrMobileUniqueatregistration?mobile=" +
                              data,
                            false
                          )
                            .then((response) => {
                              if (
                                response &&
                                response.data &&
                                response.data.error === "Unauthorized" &&
                                response.data.data.mobile === 1 &&
                                response.data.data._id !==
                                  localStorage.getItem("ID")
                              ) {
                                resolve(false);
                              } else {
                                resolve(true);
                              }
                            })
                            .catch((error) => {
                              resolve(true);
                            });
                        } else {
                          resolve(true);
                        }
                      });
                    }
                  ),
                socialMediaHandles:
                  this.state.userType == message.ACCTOWNER
                    ? Yup.object().shape({
                        facebook: Yup.string()
                          .trim()
                          .test("facebook", message.VALID_URL, (value) => {
                            if (value == "") {
                              return true;
                            }
                            var regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
                            return regexp.test(value);
                          }),
                        instagram: Yup.string()
                          .trim()
                          .test("instagram", message.VALID_URL, (value) => {
                            if (value == "") {
                              return true;
                            }
                            var regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
                            return regexp.test(value);
                          }),
                      })
                    : Yup.string().nullable(),
                isTextMsgEnabled: Yup.boolean(),
              })}
              onSubmit={(values) => {
                this.updateProfile("userInfo", values);
              }}
            >
              {({ handleChange, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs="12" sm="3">
                      <div className="profile-img profile-img-big">
                        <img
                          src={
                            this.state.selectedImage
                              ? this.state.selectedImage
                              : this.props.profileData.avatar &&
                                this.props.profileData.avatar !== "-"
                              ? UrlConstants.AdminCreateTransactionUrl +
                                "/upload?id=" +
                                this.props.profileData._id +
                                "&img=" +
                                this.props.profileData.avatar
                              : UserImage
                          }
                          alt="user"
                        />
                      </div>
                      <div className="text-center">
                        <label
                          htmlFor="userImg"
                          className="color-blue-4 font-500"
                        >
                          Edit
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          id="userImg"
                          style={{ opacity: "0", position: "absolute" }}
                          onChange={(e) => {
                            setFieldValue("avatar", e.target.files[0].name);
                            this.setState({
                              selectedImage: URL.createObjectURL(
                                e.target.files[0]
                              ),
                              profileImage: e.target.files[0],
                            });
                          }}
                        />
                      </div>
                    </Col>
                    <Col xs="12" sm="9">
                      <Row>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="control-label">
                              First Name<span className="text-danger"> *</span>
                            </label>
                            <Field
                              type="text"
                              className="form-control field_ucfirst"
                              value={values.firstname}
                              name="firstname"
                              handleChange={handleChange}
                            />
                            <ErrorMessage
                              name="firstname"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="control-label">
                              Last Name<span className="text-danger"> *</span>
                            </label>
                            <Field
                              type="text"
                              className="form-control field_ucfirst"
                              value={values.lastname}
                              name="lastname"
                              handleChange={handleChange}
                            />
                            <ErrorMessage
                              name="lastname"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>

                      {/* {this.state.userType == message.ACCTOWNER && (
                        <Row>
                          <Col xs={12} sm={6}>
                            <div className="form-group">
                              <label className="control-label">
                                License Number
                                <span className="text-danger"> *</span>
                              </label>
                              <Field
                                type="text"
                                className="form-control"
                                value={values.brokerLicenseNo}
                                name="brokerLicenseNo"
                                handleChange={handleChange}
                              ></Field>
                              <ErrorMessage
                                name="brokerLicenseNo"
                                component="div"
                                className="invalid-feedback"
                                style={{ display: "block" }}
                              />
                            </div>
                          </Col>
                          <Col xs={12} sm={6}>
                            <div className="form-group">
                              <label className="control-label">
                                License Expiration Date
                                <span className="text-danger"> *</span>
                              </label>
                              <div className="icon-wrapper blue-wrapper">
                                <DateRangePicker
                                  singleDatePicker
                                  startDate={moment(
                                    values.licenseExpirationDate
                                  ).format("MM/DD/YYYY")}
                                  alwaysShowCalendars={false}
                                  minDate={minDate}
                                  onApply={(e, value) => {
                                    setFieldValue(
                                      "licenseExpirationDate",
                                      value.startDate.format("MM/DD/YYYY")
                                    );
                                  }}
                                >
                                  <input
                                    className="form-control"
                                    name="licenseExpirationDate"
                                    type="text"
                                    size="lg"
                                    placeholder="MM/DD/YYYY"
                                    value={moment(
                                      values.licenseExpirationDate
                                    ).format("MM/DD/YYYY")}
                                    handleChange={handleChange}
                                  />
                                  <span className="form-control-icn form-control-icn-sm">
                                    <DateRange />
                                  </span>
                                </DateRangePicker>
                                <ErrorMessage
                                  name="licenseExpirationDate"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      )} */}

                      <Row>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="control-label">
                              Phone (Office):
                            </label>
                            <InputMask
                              mask="999-999-9999"
                              maskChar=""
                              formControlProps={{
                                fullWidth: true,
                              }}
                              value={values.otherNumber}
                              name="otherNumber"
                              className="form-control"
                              onChange={(e) => {
                                this.setMobile(
                                  e.target.value,
                                  "otherNumber",
                                  setFieldValue
                                );
                              }}
                            >
                              {(inputProps) => <Field {...inputProps} />}
                            </InputMask>
                            <ErrorMessage
                              name="otherNumber"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="control-label">
                              Phone (Mobile)
                              <span className="text-danger"> *</span>
                            </label>
                            <InputMask
                              mask="999-999-9999"
                              maskChar=""
                              formControlProps={{
                                fullWidth: true,
                              }}
                              className="form-control"
                              value={values.mobileNumber}
                              name="mobileNumber"
                              onChange={(e) => {
                                this.setMobile(
                                  e.target.value,
                                  "mobileNumber",
                                  setFieldValue
                                );
                              }}
                            >
                              {(inputProps) => <Field {...inputProps} />}
                            </InputMask>
                            <ErrorMessage
                              name="mobileNumber"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12}>
                          <div className="form-group">
                            <label className="control-label">Email:</label>
                            <Field
                              type="email"
                              className="form-control"
                              value={values.email ? values.email.address : ""}
                              disabled
                              name="email.address"
                              handleChange={handleChange}
                            />
                            <ErrorMessage
                              name="email.address"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>
                      {localStorage.getItem("vendorRoleName") === "Client" && (
                        <Row>
                          <Col xs={12}>
                            <div className="form-group custom-control custom-checkbox custom-control-inline custom-privacy mt-2">
                              <input
                                value={values.dsd.isTextMsgEnabled}
                                checked={values.dsd.isTextMsgEnabled}
                                type="checkbox"
                                className="custom-control-input green-checkbox"
                                id="isTextMsgEnabled"
                                name="isTextMsgEnabled"
                                onChange={(e) => {
                                  setFieldValue(
                                    "dsd.isTextMsgEnabled",
                                    e.target.checked
                                  );
                                }}
                              />
                              <label
                                className="custom-control-label f-10"
                                htmlFor="isTextMsgEnabled"
                              >
                                Opted In to receive text Messages
                              </label>
                            </div>
                          </Col>
                        </Row>
                      )}

                      {(this.state.userType == message.ACCTOWNER &&
                        userID == "") ||
                        (this.state.userData.usertype == message.ACCTOWNER && (
                          <Row>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="control-label">
                                  Facebook:
                                </label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  value={
                                    values.socialMediaHandles
                                      ? values.socialMediaHandles.facebook
                                      : ""
                                  }
                                  name="socialMediaHandles.facebook"
                                  handleChange={handleChange}
                                />
                                <ErrorMessage
                                  name="socialMediaHandles.facebook"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </div>
                            </Col>
                          </Row>
                        ))}

                      {(this.state.userType == message.ACCTOWNER &&
                        userID == "") ||
                        (this.state.userData.usertype == message.ACCTOWNER && (
                          <Row>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="control-label">
                                  Twitter:
                                </label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  value={
                                    values.socialMediaHandles
                                      ? values.socialMediaHandles.twitter
                                      : ""
                                  }
                                  name="socialMediaHandles.twitter"
                                  handleChange={handleChange}
                                />
                                <ErrorMessage
                                  name="socialMediaHandles.twitter"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </div>
                            </Col>
                          </Row>
                        ))}

                      {(this.state.userType == message.ACCTOWNER &&
                        userID == "") ||
                        (this.state.userData.usertype == message.ACCTOWNER && (
                          <Row>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="control-label">
                                  Realtor.com:
                                </label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  value={
                                    values.socialMediaHandles
                                      ? !!values.socialMediaHandles.realtor
                                        ? values.socialMediaHandles.realtor
                                        : ""
                                      : ""
                                  }
                                  name="socialMediaHandles.realtor"
                                  handleChange={handleChange}
                                />
                                <ErrorMessage
                                  name="socialMediaHandles.realtor"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </div>
                            </Col>
                          </Row>
                        ))}

                      {(this.state.userType == message.ACCTOWNER &&
                        userID == "") ||
                        (this.state.userData.usertype == message.ACCTOWNER && (
                          <Row>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="control-label">Zillow:</label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  value={
                                    values.socialMediaHandles
                                      ? !!values.socialMediaHandles.zillow
                                        ? values.socialMediaHandles.zillow
                                        : ""
                                      : ""
                                  }
                                  name="socialMediaHandles.zillow"
                                  handleChange={handleChange}
                                />
                                <ErrorMessage
                                  name="socialMediaHandles.zillow"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </div>
                            </Col>
                          </Row>
                        ))}
                    </Col>
                  </Row>
                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      type="submit"
                      size="sm"
                      className="btn-blue w-140"
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          userInfo: !this.state.userInfo,
                          selectedImage: "",
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        {/* about me modal */}
        <Modal
          show={this.state.bioInfo}
          onHide={() => this.bioModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Edit About Me
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={roleInfo}
              enableReinitialize={true}
            >
              {({ handleChange, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <CKEditor
                          onInit={(editor) => {
                            editor.ui
                              .getEditableElement()
                              .parentElement.insertBefore(
                                editor.ui.view.toolbar.element,
                                editor.ui.getEditableElement()
                              );
                          }}
                          onChange={(event, editor) => {
                            if (editor != undefined) {
                              setFieldValue("bio", editor.getData());
                            }
                          }}
                          editor={DecoupledEditor}
                          name="bio"
                          data={values.bio}
                          config={config}
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() => {
                        if (
                          this.state.userType === message.VENDOR &&
                          localStorage.getItem("vendorRoleName") === "Artist"
                        ) {
                          this.setState((prevState) => ({
                            artistDsdRoleInfo: {
                              ...prevState.artistDsdRoleInfo,
                              bio: values.bio,
                            },
                          }));
                        } else {
                          this.setState((prevState) => ({
                            dsdInfo: {
                              ...prevState.dsdInfo,
                              bio: values.bio,
                            },
                          }));
                        }

                        this.updateProfile("bioInfo", values);
                      }}
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({ bioInfo: !this.state.bioInfo })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.goalInfo}
          onHide={() => this.goalModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Goal
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.goalData}
              validationSchema={Yup.object().shape({
                name: Yup.string().required("Please enter Title"),
                description: Yup.string().required("Please enter Target"),
              })}
              enableReinitialize={true}
              onSubmit={(values, { setSubmitting }) => {
                this.updateProfile("goalInfo", values);
              }}
            >
              {({ handleChange, errors, values }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="control-label">Title</label>
                        <Field
                          type="text"
                          className="form-control field_ucfirst"
                          name="name"
                          value={values.name}
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {errors.name}
                        </div>
                      </div>
                    </Col>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="control-label">Target</label>
                        <Field
                          type="text"
                          className="form-control field_ucfirst"
                          name="description"
                          value={values.description}
                          handleChange={handleChange}
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {errors.description}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      type="submit"
                      size="sm"
                      className="btn-blue w-140"
                    >
                      {this.state.goalEdit ? "Update" : "Add"}
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({ goalInfo: !this.state.goalInfo })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.educationInfo}
          onHide={() => this.educationModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Education
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.educationData}
              enableReinitialize={true}
            >
              {({ handleChange, handleBlur, values }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="control-label">Institute</label>
                        <Field
                          type="text"
                          className="form-control field_ucfirst"
                          name="name"
                          value={values.name}
                          handleChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={6}>
                      <div className="form-group">
                        <label className="control-label">Year from</label>
                        <div className="icon-wrapper blue-wrapper">
                          <ReactSelect
                            id="fromyear"
                            placeholder="From Year"
                            onBlur={handleBlur}
                            fullWidth
                            onChange={(e) => this.setDate("educationInfo", e)}
                            value={
                              this.state.educationInfoDate
                                ? {
                                    label: this.state.educationInfoDate,
                                    value: this.state.educationInfoDate,
                                  }
                                : {
                                    label:
                                      values.description &&
                                      values.description != ""
                                        ? values.description.split("-")[0]
                                        : "",
                                    value:
                                      values.description &&
                                      values.description != ""
                                        ? values.description.split("-")[0]
                                        : "",
                                  }
                            }
                            className="react-select-wrapper react-select-multi"
                            name={"year"}
                            options={options}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div className="form-group">
                        <label className="control-label">Year to</label>

                        <div className="icon-wrapper blue-wrapper">
                          <ReactSelect
                            id="toyear"
                            placeholder="To Year"
                            onBlur={handleBlur}
                            fullWidth
                            onChange={(e) => this.setDate("educationInfo1", e)}
                            value={
                              this.state.educationInfoDate1
                                ? {
                                    label: this.state.educationInfoDate1,
                                    value: this.state.educationInfoDate1,
                                  }
                                : {
                                    label:
                                      values.description &&
                                      values.description != ""
                                        ? values.description.split("-")[1]
                                        : "",
                                    value:
                                      values.description &&
                                      values.description != ""
                                        ? values.description.split("-")[1]
                                        : "",
                                  }
                            }
                            className="react-select-wrapper react-select-multi"
                            name={"year1"}
                            options={options1}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() => {
                        this.updateProfile("educationInfo", values);
                      }}
                    >
                      {this.state.educationEdit ? "Update" : "Add"}
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          educationInfo: !this.state.educationInfo,
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.certificationsInfo}
          onHide={() => this.certificationsModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786 modal-tabindex"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Certification
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.certificationsData}
              enableReinitialize={true}
            >
              {({ handleChange, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="control-label">Institute</label>
                        <Field
                          type="text"
                          className="form-control field_ucfirst"
                          name="name"
                          value={values.name}
                          handleChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="control-label">Issued Date</label>
                        <div className="icon-wrapper blue-wrapper">
                          <DateRangePicker
                            singleDatePicker
                            startDate={values.description}
                            showDropdowns
                            onApply={(e, value) => {
                              setFieldValue(
                                "description",
                                value.startDate.format("MM/DD/YYYY")
                              );
                            }}
                          >
                            <input
                              className="form-control"
                              type="text"
                              size="lg"
                              placeholder="MM/DD/YYYY"
                              id="certDescription"
                              name="description"
                              value={values.description}
                              handleChange={handleChange}
                            />
                            <span className="form-control-icn form-control-icn-sm">
                              <DateRange />
                            </span>
                          </DateRangePicker>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() => {
                        this.updateProfile("certificationsInfo", values);
                      }}
                    >
                      {this.state.certificationsEdit ? "Update" : "Add"}
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          certificationsInfo: !this.state.certificationsInfo,
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.awardsInfo}
          onHide={() => this.awardsModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786 modal-tabindex"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Awards
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.awardsData}
              enableReinitialize={true}
            >
              {({ handleChange, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="control-label">Award</label>
                        <Field
                          type="text"
                          className="form-control field_ucfirst"
                          name="name"
                          value={values.name}
                          handleChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="control-label">Issued Date</label>
                        <div className="icon-wrapper blue-wrapper">
                          <DateRangePicker
                            singleDatePicker
                            showDropdowns
                            startDate={values.description}
                            onApply={(e, value) => {
                              setFieldValue(
                                "description",
                                value.startDate.format("MM/DD/YYYY")
                              );
                            }}
                          >
                            <input
                              className="form-control"
                              type="text"
                              size="lg"
                              id="awardsDescription"
                              placeholder="MM/DD/YYYY"
                              name="description"
                              value={values.description}
                              handleChange={handleChange}
                            />
                            <span className="form-control-icn form-control-icn-sm">
                              <DateRange />
                            </span>
                          </DateRangePicker>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() => {
                        this.updateProfile("awardsInfo", values);
                      }}
                    >
                      {this.state.awardsEdit ? "Update" : "Add"}
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({ awardsInfo: !this.state.awardsInfo })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.signatureInfo}
          onHide={() => this.signatureModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786 modal-tabindex"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Signature
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={user}
              enableReinitialize={true}
            >
              {({ values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <CKEditor
                          onInit={(editor) => {
                            editor.ui
                              .getEditableElement()
                              .parentElement.insertBefore(
                                editor.ui.view.toolbar.element,
                                editor.ui.getEditableElement()
                              );
                          }}
                          onChange={(event, editor) => {
                            if (editor != undefined) {
                              setFieldValue("signature", editor.getData());
                            }
                          }}
                          editor={DecoupledEditor}
                          name="signature"
                          data={values.signature}
                          config={config}
                        />
                      </div>
                    </Col>
                  </Row>

                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() => {
                        this.updateProfile("signatureInfo", values);
                      }}
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          signatureInfo: !this.state.signatureInfo,
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.companyInfo}
          onHide={() => this.companyModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Edit Studio Information
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.companyData}
              enableReinitialize={true}
              validationSchema={Yup.object().shape({
                name: Yup.string()
                  .trim()
                  .required(message.ENTER_COMPANY_NAME),
                address: Yup.string()
                  .trim()
                  .required(message.ENTER_COMPANY_ADDRESS),
                city: Yup.string()
                  .trim()
                  .required(message.ENTER_CITY),
                state: Yup.string()
                  .trim()
                  .required(message.SELECT_STATE),
                website: Yup.string()
                  .url("this field must be an URL.(ex : http://something.com)")
                  .nullable(),
                publicUrl: Yup.string()
                  .required(message.ENTER_PUBLIC_URL_POSTFIX)
                  .matches(new RegExp("^[a-z0-9- ]{2,30}$"), {
                    message: message.PUBLIC_URL_POSTFIX_INVALID,
                  })
                  .test(
                    "publicUrl",
                    message.PUBLIC_URL_POSTFIX_EXISTS,
                    (value) => {
                      return new Promise((resolve, reject) => {
                        if (value) {
                          let data = {
                            publicUrl: value,
                          };
                          this.props
                            .checkDuplicatePublicUrlPostfixAction(data)
                            .then((res) => {
                              if (res.status !== code.OK) {
                                resolve(false);
                              } else {
                                resolve(true);
                              }
                            })
                            .catch((error) => {
                              resolve(true);
                            });
                        } else {
                          resolve(true);
                        }
                      });
                    }
                  ),
                defaultBookingAmount: Yup.string()
                  .required(message.ENTER_AMOUNT)
                  .matches(
                    new RegExp(
                      "^([0-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$"
                    ),
                    {
                      message: message.ENTER_VALID_AMOUNT,
                    }
                  ),
                zipcode: Yup.string()
                  .required(message.ENTER_ZIP)
                  .matches(new RegExp("^[0-9]{5}(?:-[0-9]{4})?$"), {
                    message: message.ENTER_VALID_ZIP,
                    excludeEmptyString: true,
                  }),
                phoneNumber: Yup.string()
                  .required(message.ENTER_PHONE)
                  .length(10, message.PHONE_10_DIGIT),
              })}
              onSubmit={(values) => {
                this.setState({ companyData: values });
                this.updateProfile("companyInfo", values);
              }}
            >
              {({ handleChange, errors, touched, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs="12" sm="4">
                      <div className="profile-img profile-img-big">
                        <img
                          src={
                            this.state.selectedCompanyLogo
                              ? this.state.selectedCompanyLogo
                              : values.studioLogo && values.studioLogo !== "-"
                              ? UrlConstants.AdminCreateTransactionUrl +
                                "/upload?id=" +
                                this.props.profileData._id +
                                "&img=" +
                                values.studioLogo
                              : UserImage
                          }
                          alt="user"
                        />
                      </div>
                      <div className="text-center">
                        <label
                          htmlFor="companyLogo"
                          className="color-blue-4 font-500"
                        >
                          Edit
                        </label>
                        <input
                          type="file"
                          id="companyLogo"
                          accept="image/*"
                          style={{ opacity: "0", position: "absolute" }}
                          onChange={(e) => {
                            setFieldValue("studioLogo", e.target.files[0].name);
                            this.setState({
                              selectedCompanyLogo: URL.createObjectURL(
                                e.target.files[0]
                              ),
                              companyLogo: e.target.files[0],
                            });
                          }}
                        />
                      </div>
                    </Col>
                    <Col xs={8}>
                      <div className="form-group">
                        <label className="control-label">
                          Name<span className="text-danger"> *</span>
                        </label>
                        <Field
                          type="text"
                          className="form-control field_ucfirst"
                          value={values ? values.name : ""}
                          name="name"
                          handleChange={handleChange}
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={5}>
                      <div className="form-group">
                        <label className="control-label">
                          Public Profile URL
                          <span className="text-danger"> *</span>
                          <Button
                            variant="transparent"
                            className="edit-icn p-0"
                            onClick={() =>
                              window.open(this.getStudioProfileUrl(), "_blank")
                            }
                            style={{ marginRight: "30px" }}
                          >
                            <OpenInNew />
                          </Button>
                          <Button
                            variant="transparent"
                            className="edit-icn p-0"
                            onClick={() => {
                              navigator.clipboard.writeText(
                                this.getStudioProfileUrl()
                              );
                              document.getElementById(
                                "custom-tooltip"
                              ).style.display = "inline";
                              setTimeout(function() {
                                document.getElementById(
                                  "custom-tooltip"
                                ).style.display = "none";
                              }, 1000);
                            }}
                          >
                            <ContentCopy />
                          </Button>
                          <span id="custom-tooltip">Copied!</span>
                        </label>
                        <label
                          className="control-label"
                          style={{ marginTop: "5px" }}
                        >
                          {UrlConstants.publicProfileUrl}
                        </label>
                      </div>
                    </Col>
                    <Col xs={3}>
                      <div className="form-group">
                        <Field
                          type="text"
                          className="form-control"
                          style={{ marginTop: "26px" }}
                          value={values.publicUrl ? values.publicUrl : ""}
                          name="publicUrl"
                          // handleChange={handleChange}
                          onChange={(e) => {
                            setFieldValue(
                              "publicUrl",
                              tranformStrToVar(e.target.value)
                            );
                          }}
                        />
                        <ErrorMessage
                          name="publicUrl"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="form-group">
                        <label
                          className="form-label"
                          htmlFor="defaultBookingAmount"
                        >
                          Default Booking Amount
                          <span className="text-danger"> *</span>
                        </label>

                        {this.state.amountFocus ? (
                          <input
                            type="text"
                            name="defaultBookingAmount"
                            className={
                              "form-control text-right amount-input" +
                              (errors.defaultBookingAmount &&
                              touched.defaultBookingAmount
                                ? " is-invalid"
                                : "")
                            }
                            value={
                              values.defaultBookingAmount
                                ? values.defaultBookingAmount
                                : "0"
                            }
                            onChange={(e) => {
                              setFieldValue(
                                "defaultBookingAmount",
                                e.target.value
                              );
                            }}
                            onBlur={() => {
                              this.setState({
                                amountFocus: false,
                              });
                            }}
                          />
                        ) : (
                          <input
                            type="text"
                            name="defaultBookingAmount"
                            className={
                              "form-control text-right " +
                              (errors.defaultBookingAmount &&
                              touched.defaultBookingAmount
                                ? " is-invalid"
                                : "")
                            }
                            onFocus={() => {
                              this.setState({ amountFocus: true }, () => {
                                $(".amount-input").focus();
                              });
                            }}
                            value={currencyFormat(values.defaultBookingAmount)}
                            defaultValue={
                              values.defaultBookingAmount
                                ? currencyFormat(values.defaultBookingAmount)
                                : currencyFormat(0)
                            }
                          />
                        )}
                        <ErrorMessage
                          name="defaultBookingAmount"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="control-label">Website</label>
                        <Field
                          type="text"
                          className="form-control"
                          value={values.website ? values.website : ""}
                          name="website"
                          handleChange={handleChange}
                        />
                        <ErrorMessage
                          name="website"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="control-label">
                          Address<span className="text-danger"> *</span>
                        </label>
                        <Field
                          type="text"
                          className="form-control field_ucfirst"
                          value={values.address ? values.address : ""}
                          name="address"
                          handleChange={handleChange}
                        />
                        <ErrorMessage
                          name="address"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={4}>
                      <div className="form-group">
                        <label className="control-label">
                          Zip Code<span className="text-danger"> *</span>
                        </label>
                        <Field
                          type="text"
                          className="form-control"
                          value={values.zipcode ? values.zipcode : ""}
                          name="zipcode"
                          handleChange={handleChange}
                          onChange={(e) => {
                            setFieldValue("zipcode", e.target.value);
                            let zipcode = e.target.value;
                            let checkZip = zipcode.toString();
                            checkZip = checkZip.replace(/\-/g, "");
                            if (
                              zipcode != "00000" &&
                              (checkZip.length === 5 || checkZip.length === 9)
                            ) {
                              this.props
                                .getAddressFromZipcodeAction(checkZip)
                                .then((res) => {
                                  setFieldValue("city", res.city);
                                  setFieldValue("state", res.state);
                                });
                            } else {
                              setFieldValue("city", "");
                              setFieldValue("state", "");
                            }
                          }}
                        />
                        <ErrorMessage
                          name="zipcode"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="form-group">
                        <label className="control-label">
                          City<span className="text-danger"> *</span>
                        </label>
                        <Field
                          type="text"
                          className="form-control field_ucfirst"
                          value={values.city ? values.city : ""}
                          name="city"
                          handleChange={handleChange}
                        />
                        <ErrorMessage
                          name="city"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="form-group">
                        <label className="control-label">
                          State<span className="text-danger"> *</span>
                        </label>
                        <div className="c-select">
                          <Field
                            component="select"
                            className="form-control"
                            placeholder="State"
                            value={values.state ? values.state : ""}
                            name="state"
                            handleChange={handleChange}
                          >
                            <option value="">Select</option>;
                            {stateDropDownValue}
                          </Field>
                        </div>
                        <ErrorMessage
                          name="state"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={6}>
                      <div className="form-group">
                        <label className="control-label">
                          Phone<span className="text-danger"> *</span>
                        </label>
                        <InputMask
                          mask="999-999-9999"
                          maskChar=""
                          formControlProps={{
                            fullWidth: true,
                          }}
                          className="form-control"
                          value={values.phoneNumber ? values.phoneNumber : ""}
                          name="phoneNumber"
                          onChange={(e) => {
                            this.setMobile(
                              e.target.value,
                              "phoneNumber",
                              setFieldValue
                            );
                          }}
                        >
                          {(inputProps) => <Field {...inputProps} />}
                        </InputMask>
                        <ErrorMessage
                          name="phoneNumber"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div className="form-group">
                        <label className="control-label">Fax</label>
                        <InputMask
                          mask="999-999-9999"
                          maskChar=""
                          formControlProps={{
                            fullWidth: true,
                          }}
                          className="form-control"
                          value={values.faxNumber ? values.faxNumber : ""}
                          name="faxNumber"
                          onChange={(e) => {
                            this.setMobile(
                              e.target.value,
                              "faxNumber",
                              setFieldValue
                            );
                          }}
                        >
                          {(inputProps) => <Field {...inputProps} />}
                        </InputMask>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={6}>
                      <div className="form-group">
                        <label className="control-label">
                          Type of Business
                        </label>
                        <div className="c-select">
                          <Field
                            component="select"
                            className="form-control"
                            placeholder="Type of Business"
                            value={
                              values.typeOfBusiness ? values.typeOfBusiness : ""
                            }
                            name="typeOfBusiness"
                            handleChange={handleChange}
                          >
                            <option value="">Select</option>
                            <option value="Brokerage">Brokerage</option>
                          </Field>
                        </div>
                        <ErrorMessage
                          name="typeOfBusiness"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div className="form-group">
                        <label className="control-label">Company Size</label>
                        <div className="c-select">
                          <Field
                            component="select"
                            className="form-control"
                            placeholder="Company Size"
                            value={values.companySize ? values.companySize : ""}
                            name="companySize"
                            handleChange={handleChange}
                          >
                            <option value="">Select</option>
                            <option value="1-10">Small (1-10)</option>
                            <option value="11-24">Medium (11-24)</option>
                            <option value="24+">Large (24+)</option>
                          </Field>
                        </div>
                        <ErrorMessage
                          name="companySize"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12}>
                      <label className="control-label">About Studio </label>
                      <div className="form-group">
                        <textarea
                          rows={5}
                          className="form-control"
                          name="aboutCompany"
                          value={values.aboutCompany}
                          onChange={(e) => {
                            setFieldValue("aboutCompany", e.target.value);
                          }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12}>
                      <label className="control-label">
                        Studio Working Hours{" "}
                      </label>
                      <div className="form-group">
                        <textarea
                          rows={5}
                          className="form-control"
                          name="availability"
                          value={values.availability}
                          onChange={(e) => {
                            setFieldValue("availability", e.target.value);
                          }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={3}>
                      <div className="form-group">
                        <div className="form-check">
                          <label className="form-check-label">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="includeWeekend"
                              checked={values.includeWeekend}
                              onChange={(e) => {
                                setFieldValue(
                                  "includeWeekend",
                                  e.target.checked
                                );
                              }}
                            />
                            Include Weekend
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col xs={3}>
                      <div className="form-group">
                        <div className="form-check">
                          <label className="form-check-label">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="includeUSHolidays"
                              checked={values.includeUSHolidays}
                              onChange={(e) => {
                                setFieldValue(
                                  "includeUSHolidays",
                                  e.target.checked
                                );
                              }}
                            />
                            Include US Holidays
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div className="form-group" style={{ display: "flex" }}>
                        <label
                          className="date-label"
                          style={{ paddingRight: "12px" }}
                        >
                          Default Duration
                        </label>
                        <select
                          className="form-control form-control-sm pl-1 date-picker date-duration"
                          style={{ width: "30%", height: "30px" }}
                          value={
                            values.defaultDuration ? values.defaultDuration : 30
                          }
                          onChange={(e) =>
                            setFieldValue("defaultDuration", e.target.value)
                          }
                        >
                          <option value={15}>15 minutes</option>
                          <option value={20}>20 minutes</option>
                          <option value={30}>30 minutes</option>
                          <option value={45}>45 minutes</option>
                          <option value={60}>1 hour</option>
                          <option value={120}>2 hours</option>
                          <option value={180}>3 hours</option>
                          <option value={240}>4 hours</option>
                        </select>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col xs={12}>
                      <>
                        <h6>Suggested example text:</h6>
                        <div style={{ fontSize: "0.8rem" }}>
                          1. **Every Day:** Every day of the week. <br />
                          2. **Regular Hours:** From 8:00 AM to 3:00 PM on most
                          days.
                          <br />
                          3. **Exception on Thursdays:** On Thursdays, starts
                          work later, at 10:00 AM, and is available until 3:00
                          PM. <br />
                          4. **Exception on the Second Tuesday of the Month:**
                          On the second Tuesday of each month, starts work at
                          10:00 AM instead of 8:00 AM, and is available until
                          3:00 PM.
                          <br />
                          5. On Vacations From 10th Sept to 20 Sept.
                        </div>
                      </>
                    </Col>
                  </Row>

                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      type="submit"
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          companyInfo: !this.state.companyInfo,
                          selectedCompanyLogo: "",
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        {/* Public profile url for artists */}
        <Modal
          show={this.state.artistPublicUrlInfo}
          onHide={() => this.artistPublicUrlInfoModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Public Profile URL{" "}
              {localStorage.getItem("companyName")
                ? "for " + localStorage.getItem("companyName")
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.dsdInfo}
              enableReinitialize={true}
              validationSchema={Yup.object().shape({
                publicUrl: Yup.string()
                  .required(message.ENTER_PUBLIC_URL_POSTFIX)
                  .matches(new RegExp("^[a-z0-9- ]{2,30}$"), {
                    message: message.PUBLIC_URL_POSTFIX_INVALID,
                  })
                  .test(
                    "publicUrl",
                    message.PUBLIC_URL_POSTFIX_EXISTS,
                    (value) => {
                      return new Promise((resolve, reject) => {
                        if (value) {
                          let data = {
                            publicUrl: value,
                            ownerId: this.state.ownerId,
                            roleId:
                              (this.state.userData &&
                                this.state.userData.dsd &&
                                checkObjExists(this.state.userData.dsd) &&
                                this.state.userData.dsd.roles &&
                                this.state.userData.dsd.roles.length > 0 &&
                                this.state.userData.dsd.roles[0].roleId) ||
                              "",
                          };
                          this.props
                            .checkArtistDuplicatePublicUrlAction(data)
                            .then((res) => {
                              if (res.status !== code.OK) {
                                resolve(false);
                              } else {
                                resolve(true);
                              }
                            })
                            .catch((error) => {
                              resolve(true);
                            });
                        } else {
                          resolve(true);
                        }
                      });
                    }
                  ),
                defaultBookingAmount: Yup.string()
                  .required(message.ENTER_AMOUNT)
                  .matches(
                    new RegExp(
                      "^([0-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$"
                    ),
                    {
                      message: message.ENTER_VALID_AMOUNT,
                    }
                  ),
              })}
              onSubmit={(values) => {
                if (
                  (this.state.userType == message.ACCTOWNER && userID == "") ||
                  this.state.userData.usertype == message.ACCTOWNER
                ) {
                  this.setState((prevState) => ({
                    artistPublicUrlInfoExists: true,
                    dsdInfo: {
                      ...prevState.dsdInfo,
                      allowPublicProfile: values.allowPublicProfile,
                      allowPublicScheduling: values.allowPublicScheduling,
                    },
                  }));
                }
                this.setState((prevState) => ({
                  artistPublicUrlInfoExists: true,
                  dsdInfo: {
                    ...prevState.dsdInfo,
                    publicUrl: values.publicUrl,
                    defaultBookingAmount: values.defaultBookingAmount,
                  },
                }));
                if (
                  !this.state.allowPublicProfileUrlErr &&
                  !this.state.allowPublicSchedulingErr
                ) {
                  this.updateProfile("publicUrlInfo", values);
                  this.artistPublicUrlInfoModal();
                }
              }}
            >
              {({ handleChange, errors, touched, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={5}>
                      <div className="form-group">
                        <label className="control-label">
                          Public Profile URL
                          <span className="text-danger"> *</span>
                        </label>
                        <label
                          className="control-label"
                          style={{ marginTop: "5px" }}
                        >
                          {UrlConstants.artistPublicProfileUrl}
                        </label>
                      </div>
                    </Col>
                    <Col xs={3}>
                      <div className="form-group">
                        <Field
                          type="text"
                          className="form-control"
                          style={{ marginTop: "26px" }}
                          value={values.publicUrl ? values.publicUrl : ""}
                          name="publicUrl"
                          // handleChange={handleChange}
                          onChange={(e) => {
                            setFieldValue(
                              "publicUrl",
                              tranformStrToVar(e.target.value)
                            );
                          }}
                        />
                        <ErrorMessage
                          name="publicUrl"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="form-group">
                        <label
                          className="form-label"
                          htmlFor="defaultBookingAmount"
                        >
                          Default Booking Amount
                          <span className="text-danger"> *</span>
                        </label>

                        {this.state.amountFocus ? (
                          <input
                            type="text"
                            name="defaultBookingAmount"
                            className={
                              "form-control text-right amount-input" +
                              (errors.defaultBookingAmount &&
                              touched.defaultBookingAmount
                                ? " is-invalid"
                                : "")
                            }
                            value={
                              values.defaultBookingAmount
                                ? values.defaultBookingAmount
                                : "0"
                            }
                            onChange={(e) => {
                              setFieldValue(
                                "defaultBookingAmount",
                                e.target.value
                              );
                            }}
                            onBlur={() => {
                              this.setState({
                                amountFocus: false,
                              });
                            }}
                          />
                        ) : (
                          <input
                            type="text"
                            name="defaultBookingAmount"
                            className={
                              "form-control text-right " +
                              (errors.defaultBookingAmount &&
                              touched.defaultBookingAmount
                                ? " is-invalid"
                                : "")
                            }
                            onFocus={() => {
                              this.setState({ amountFocus: true }, () => {
                                $(".amount-input").focus();
                              });
                            }}
                            value={currencyFormat(values.defaultBookingAmount)}
                            defaultValue={
                              values.defaultBookingAmount
                                ? currencyFormat(values.defaultBookingAmount)
                                : currencyFormat(0)
                            }
                          />
                        )}
                        <ErrorMessage
                          name="defaultBookingAmount"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>
                  {((this.state.userType == message.ACCTOWNER &&
                    userID == "") ||
                    this.state.userData.usertype == message.ACCTOWNER) && (
                    <Row>
                      <Col xs={4}>
                        <div className="form-group">
                          <div className="form-check">
                            <label className="form-check-label">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                name="allowPublicProfile"
                                checked={values.allowPublicProfile}
                                onChange={(e) => {
                                  this.checkPublicScheduling(
                                    values,
                                    setFieldValue,
                                    "allowPublicProfile",
                                    e.target.checked
                                  );
                                }}
                              />
                              Allow Public Profile
                            </label>
                          </div>
                          {this.state.allowPublicProfileUrlErr && (
                            <label
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              Allow Public Scheduling is active.
                            </label>
                          )}
                        </div>
                      </Col>
                      <Col xs={4}>
                        <div className="form-group">
                          <div className="form-check">
                            <label className="form-check-label">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                name="allowPublicScheduling"
                                checked={values.allowPublicScheduling}
                                onChange={(e) => {
                                  this.checkPublicProfileUrl(
                                    values,
                                    setFieldValue,
                                    "allowPublicScheduling",
                                    e.target.checked
                                  );
                                }}
                              />
                              Allow Public Scheduling
                            </label>
                          </div>

                          {this.state.allowPublicSchedulingErr && (
                            <label
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              Allow Public Profile is not checked.
                            </label>
                          )}
                        </div>
                      </Col>
                    </Row>
                  )}

                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      type="submit"
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          artistPublicUrlInfo: !this.state.artistPublicUrlInfo,
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.brokerageInfo}
          onHide={() => this.brokerageModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Edit Commission
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={user}
              enableReinitialize={true}
              validationSchema={Yup.object().shape({
                agentPercentage: Yup.number()
                  .required(message.ENTER_PERCENTAGE)
                  .min(0.01, "Agent Percentage must be greater than 0 %"),
              })}
              onSubmit={(values) => {
                this.updateProfile("fees", values);
              }}
            >
              {({ errors, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12} sm={6}>
                      <div className="form-group" controlId="">
                        <div className="form-label">Agent %</div>
                        <NumericInput
                          name="agentPercentage"
                          precision={2}
                          min={0}
                          max={100}
                          inputmode="numeric"
                          strict
                          style={false}
                          className="form-control"
                          value={
                            values.agentPercentage !== undefined &&
                            values.agentPercentage !== null
                              ? values.agentPercentage
                              : 100.0
                          }
                          onChange={(e) => {
                            setFieldValue("agentPercentage", e.toFixed(2));
                            setFieldValue(
                              "brokerPercentage",
                              (100 - e).toFixed(2)
                            );
                          }}
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {errors.agentPercentage}
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className="form-group" controlId="">
                        <div className="form-label">Brokerage %</div>
                        <NumericInput
                          name="brokerPercentage"
                          precision={2}
                          min={0}
                          max={100}
                          inputmode="numeric"
                          strict
                          style={false}
                          className="form-control"
                          value={values.brokerPercentage}
                          disabled
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      type="submit"
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          brokerageInfo: !this.state.brokerageInfo,
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.deletePrompt}
          onHide={() => this.deletePrompt()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}
        >
          <Modal.Body className="pb-0 text-center">
            <HelpOutline />
            <p>Are you sure you want to delete?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.deletePrompt();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.confirmDelete(
                  this.state.deleteType,
                  this.state.deleteIndex
                );
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>

        {/* license details modal */}
        <Modal
          show={this.state.dsdInfoPrompt}
          onHide={() => this.dsdInfoModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Edit Data
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.dsdInfo}
              enableReinitialize={true}
              validationSchema={Yup.object().shape({
                // role: Yup.string().required("Please select role."),
                brokerLicenseNo: Yup.string()
                  .trim()
                  .required("Please enter License Number."),
              })}
              onSubmit={(values) => {
                // console.log(
                //   "licenseExpirationDate",
                //   values.licenseExpirationDate
                // );
                // object that we want to update
                // keep all other key-value pairs
                // update the value of specific key
                this.setState((prevState) => ({
                  dsdInfo: {
                    ...prevState.dsdInfo,
                    brokerLicenseNo: values.brokerLicenseNo,
                    licenseExpirationDate:
                      values.licenseExpirationDate ||
                      moment().format("MM/DD/YYYY"),
                  },
                }));
                this.updateProfile("dsd", values);
              }}
            >
              {({ handleChange, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <label className="control-label">
                          License Number
                          <span className="text-danger"> *</span>
                        </label>
                        <Field
                          type="text"
                          className="form-control"
                          value={values.brokerLicenseNo}
                          name="brokerLicenseNo"
                          handleChange={handleChange}
                        />
                        <ErrorMessage
                          name="brokerLicenseNo"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <label className="control-label">
                          License Expiration Date
                          <span className="text-danger"> *</span>
                        </label>
                        <div className="icon-wrapper blue-wrapper">
                          <DateRangePicker
                            singleDatePicker
                            startDate={moment(
                              values.licenseExpirationDate
                            ).format("MM/DD/YYYY")}
                            alwaysShowCalendars={false}
                            minDate={minDate}
                            onApply={(e, value) => {
                              setFieldValue(
                                "licenseExpirationDate",
                                value.startDate.format("MM/DD/YYYY")
                              );
                            }}
                          >
                            <input
                              className="form-control"
                              name="licenseExpirationDate"
                              type="text"
                              size="lg"
                              placeholder="MM/DD/YYYY"
                              value={moment(
                                values.licenseExpirationDate
                                  ? values.licenseExpirationDate
                                  : new Date()
                              ).format("MM/DD/YYYY")}
                              handleChange={handleChange}
                            />
                            <span className="form-control-icn form-control-icn-sm">
                              <DateRange />
                            </span>
                          </DateRangePicker>
                          <ErrorMessage
                            name="licenseExpirationDate"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      type="submit"
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          dsdInfoPrompt: !this.state.dsdInfoPrompt,
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        {/* set auto complition of transactions */}
        <Modal
          show={this.state.autocompletesettingmodel}
          onHide={() => this.autoComplitionsettingModel()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Edit Autocomplete Transaction Setting
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.autocompletesetting}
              enableReinitialize={true}
              onSubmit={(values) => {
                this.setState({
                  autocompletesetting: {
                    autoCompleteTransactions: values.autoCompleteTransactions,
                    autoCompleteTransactionsDays:
                      values.autoCompleteTransactionsDays,
                  },
                });
                this.updateProfile("transactionAutoComplete", values);
              }}
            >
              {({ handleChange, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <div>
                          <label className="control-label">
                            Autocomplete <span className="text-danger"> *</span>
                          </label>
                          <Row>
                            <div class="col-4 mt-2">
                              <label className="control-label mr-1">ON </label>
                              <Field
                                type="radio"
                                checked={
                                  values.autoCompleteTransactions === true
                                }
                                name="autoCompleteTransactions"
                                onChange={() =>
                                  setFieldValue(
                                    "autoCompleteTransactions",
                                    true
                                  )
                                }
                                value={true}
                              />
                            </div>
                            <div class="col-4 mt-2">
                              <label className="control-label mr-1">OFF </label>
                              <Field
                                type="radio"
                                checked={
                                  values.autoCompleteTransactions === false
                                }
                                name="autoCompleteTransactions"
                                onChange={() =>
                                  setFieldValue(
                                    "autoCompleteTransactions",
                                    false
                                  )
                                }
                                value={false}
                              />
                            </div>
                          </Row>
                          <ErrorMessage
                            name="autoCompleteTransactions"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          />
                        </div>
                      </div>
                    </Col>
                    {values.autoCompleteTransactions ? (
                      <Col xs={12} sm={4}>
                        <div className="form-group">
                          <label className="control-label">
                            Days
                            <span className="text-danger"> *</span>
                          </label>
                          <Field
                            type="number"
                            required
                            pattern="[1-9]*"
                            min="1"
                            max="365"
                            className="form-control"
                            value={values.autoCompleteTransactionsDays}
                            name="autoCompleteTransactionsDays"
                            handleChange={handleChange}
                            autocomplete="off"
                          />
                          <ErrorMessage
                            name="autoCompleteTransactionsDays"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          />
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                  </Row>
                  <Row>
                    <div
                      className="col-sm-12 col-12"
                      style={{ fontSize: "12px", color: "#d09e07" }}
                    >
                      Note: Artworks will be marked completed automatically
                      after the number of days provided by you with respect to
                      the last scheduled task of each Artwork.
                    </div>
                  </Row>

                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      type="submit"
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          autocompletesettingmodel: !this.state
                            .autocompletesettingmodel,
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        {/* set auto complition of transactions */}
        <Modal
          show={this.state.billingSettingModal}
          onHide={() => this.billingSettingModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Edit Card Process Billing Settings
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.billingSettingData}
              enableReinitialize={true}
              validationSchema={Yup.object().shape({
                mid: Yup.string()
                  .trim()
                  .required(message.ENTER_MID),
                developerKey: Yup.string()
                  .trim()
                  .required(message.ENTER_DEVELOPER_KEY),
                apiPassword: Yup.string()
                  .trim()
                  .required(message.ENTER_API_PASSWORD),
                appSource: Yup.string()
                  .trim()
                  .required(message.ENTER_APPSOURCE),
                invoicePrefix: Yup.string()
                  .trim()
                  .required(message.ENTER_INVOICE_PREFIX)
                  .matches(new RegExp("^[A-Z0-9]{2,6}$"), {
                    message: message.INVOICE_PREFIX_INVALID,
                  })
                  .test(
                    "invoicePrefix",
                    message.INVOICE_PREFIX_EXISTS,
                    (value) => {
                      return new Promise((resolve, reject) => {
                        if (value) {
                          let data = {
                            invoicePrefix: value,
                          };
                          this.props
                            .checkDuplicateInvoicePrefixAction(data)
                            .then((res) => {
                              if (res.status !== code.OK) {
                                resolve(false);
                              } else {
                                resolve(true);
                              }
                            })
                            .catch((error) => {
                              resolve(true);
                            });
                        } else {
                          resolve(true);
                        }
                      });
                    }
                  ),
              })}
              onSubmit={(values) => {
                this.setState({
                  billingSettingData: {
                    billingSettingStatus: values.billingSettingStatus,
                    mid: values.mid,
                    developerKey: values.developerKey,
                    apiPassword: values.apiPassword,
                    invoicePrefix: values.invoicePrefix,
                    serviceFeeEnabled: values.serviceFeeEnabled,
                    appSource: values.appSource,
                  },
                });
                this.updateUserBillingSetting(values);
              }}
            >
              {({ handleChange, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12} sm={6}>
                      <div className="form-group">
                        <div>
                          <label className="control-label">
                            Card Process Billing Setting{" "}
                          </label>
                          <ErrorMessage
                            name="billingSettingStatus"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <div style={{ display: "display-inline" }}>
                        <label className="control-label mr-1">ON </label>
                        <Field
                          type="radio"
                          checked={values.billingSettingStatus === true}
                          name="billingSettingStatus"
                          onChange={() =>
                            setFieldValue("billingSettingStatus", true)
                          }
                          value={true}
                          className="mr-5"
                        />
                        <label className="control-label mr-1">OFF </label>
                        <Field
                          type="radio"
                          checked={values.billingSettingStatus === false}
                          name="billingSettingStatus"
                          onChange={() =>
                            setFieldValue("billingSettingStatus", false)
                          }
                          value={false}
                        />
                      </div>
                    </Col>
                  </Row>
                  {values.billingSettingStatus ? (
                    <>
                      <Row>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="control-label">
                              MID
                              <span className="text-danger"> *</span>
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              value={values.mid}
                              name="mid"
                              handleChange={handleChange}
                              autocomplete="off"
                            />
                            <ErrorMessage
                              name="mid"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="control-label">
                              Developer Key
                              <span className="text-danger"> *</span>
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              value={values.developerKey}
                              name="developerKey"
                              handleChange={handleChange}
                              autocomplete="off"
                            />
                            <ErrorMessage
                              name="developerKey"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="control-label">
                              API Password
                              <span className="text-danger"> *</span>
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              value={values.apiPassword}
                              name="apiPassword"
                              handleChange={handleChange}
                              autocomplete="off"
                            />
                            <ErrorMessage
                              name="apiPassword"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="control-label">
                              Invoice Prefix
                              <span className="text-danger"> *</span>
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              value={values.invoicePrefix}
                              name="invoicePrefix"
                              onChange={(e) => {
                                setFieldValue(
                                  "invoicePrefix",
                                  e.target.value.toUpperCase()
                                );
                              }}
                              autocomplete="off"
                              maxlength={6}
                            />
                            <ErrorMessage
                              name="invoicePrefix"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="control-label">
                              Appsource
                              <span className="text-danger"> *</span>
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              value={values.appSource}
                              name="appSource"
                              handleChange={handleChange}
                              autocomplete="off"
                            />
                            <ErrorMessage
                              name="appSource"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <div>
                              <label
                                className="control-label"
                                title="Convenience Fee"
                              >
                                Conv Fee{" "}
                              </label>
                              <ErrorMessage
                                name="serviceFeeEnabled"
                                component="div"
                                className="invalid-feedback"
                                style={{ display: "block" }}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={6}>
                          <div style={{ display: "display-inline" }}>
                            <label className="control-label mr-1">ON </label>
                            <Field
                              type="radio"
                              checked={values.serviceFeeEnabled === true}
                              name="serviceFeeEnabled"
                              onChange={() =>
                                setFieldValue("serviceFeeEnabled", true)
                              }
                              value={true}
                              className="mr-5"
                            />
                            <label className="control-label mr-1">OFF </label>
                            <Field
                              type="radio"
                              checked={values.serviceFeeEnabled === false}
                              name="serviceFeeEnabled"
                              onChange={() =>
                                setFieldValue("serviceFeeEnabled", false)
                              }
                              value={false}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} sm={12}>
                          <div className="form-group">
                            <h6>Note: </h6>
                            <div style={{ "font-size": "0.8rem" }}>
                              Laws regarding Convenience Fees differ between
                              states and even locality. Please ensure you are
                              following all applicable laws for your business.
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      type="submit"
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() => this.billingSettingModal()}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        {/* set campaign default*/}
        <Modal
          show={this.state.campaignDefaultSettingPrompt}
          onHide={() => this.campaignDefaultSettingModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Edit Default Campaign Setting
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.campaignDefaultSetting}
              enableReinitialize={true}
              onSubmit={(values) => {
                this.updateCampaignDefault(values);
              }}
            >
              {({ handleChange, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="control-label">
                          Campaigns <span className="text-danger"> *</span>
                        </label>
                        <div className="c-select">
                          <Field
                            component="select"
                            className="form-control"
                            placeholder="Select"
                            value={values.id}
                            name="campaign"
                            onChange={(e) => {
                              setFieldValue("id", e.target.value);
                            }}
                            required
                          >
                            <option value="">Select</option>;
                            {this.state.userCampaigns.map((e) => {
                              return (
                                <option key={e._id} value={e._id}>
                                  {e.name}
                                </option>
                              );
                            })}
                          </Field>
                        </div>
                        <ErrorMessage
                          name="campaign"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      type="submit"
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          campaignDefaultSettingPrompt: !this.state
                            .campaignDefaultSettingPrompt,
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>
        {/* set pathway default*/}
        <Modal
          show={this.state.pathwayDefaultSettingPrompt}
          onHide={() => this.pathwayDefaultSettingModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Edit Default Pathway Setting
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.pathwayDefaultSetting}
              enableReinitialize={true}
              onSubmit={(values) => {
                this.updatePathwayDefault(values);
              }}
            >
              {({ handleChange, values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <label className="control-label">
                          Pathways <span className="text-danger"> *</span>
                        </label>
                        <div className="c-select">
                          <Field
                            component="select"
                            className="form-control"
                            placeholder="Select"
                            value={values.id}
                            name="pathway"
                            onChange={(e) => {
                              setFieldValue("id", e.target.value);
                            }}
                            required
                          >
                            <option value="">Select</option>;
                            {this.state.userPathways.map((e) => {
                              return (
                                <option key={e._id} value={e._id}>
                                  {e.name}
                                </option>
                              );
                            })}
                          </Field>
                        </div>
                        <ErrorMessage
                          name="pathway"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      type="submit"
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          pathwayDefaultSettingPrompt: !this.state
                            .pathwayDefaultSettingPrompt,
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.availabilityInfo}
          onHide={() => this.availabilityModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-786 modal-tabindex"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Availability{" "}
              {localStorage.getItem("companyName")
                ? `for ${localStorage.getItem("companyName")}`
                : ""}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            <Formik
              validateOnBlur={true}
              initialValues={this.state.dsdInfo}
              enableReinitialize={true}
            >
              {({ values, setFieldValue }) => (
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12}>
                      <div className="form-group">
                        <textarea
                          rows={5}
                          className="form-control"
                          name="availability"
                          value={values.availability}
                          onChange={(e) => {
                            setFieldValue("availability", e.target.value);
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={3}>
                      <div className="form-group">
                        <div className="form-check">
                          <label className="form-check-label">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="includeWeekend"
                              checked={values.includeWeekend}
                              onChange={(e) => {
                                setFieldValue(
                                  "includeWeekend",
                                  e.target.checked
                                );
                              }}
                            />
                            Include Weekend
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col xs={3}>
                      <div className="form-group">
                        <div className="form-check">
                          <label className="form-check-label">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="includeUSHolidays"
                              checked={values.includeUSHolidays}
                              onChange={(e) => {
                                setFieldValue(
                                  "includeUSHolidays",
                                  e.target.checked
                                );
                              }}
                            />
                            Include US Holidays
                          </label>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div className="form-group" style={{ display: "flex" }}>
                        <label
                          className="date-label"
                          style={{ paddingRight: "12px" }}
                        >
                          Default Duration
                        </label>
                        <select
                          className="form-control form-control-sm pl-1 date-picker date-duration"
                          style={{ width: "30%", height: "30px" }}
                          value={
                            values.defaultDuration ? values.defaultDuration : 30
                          }
                          onChange={(e) =>
                            setFieldValue("defaultDuration", e.target.value)
                          }
                        >
                          <option value={15}>15 minutes</option>
                          <option value={20}>20 minutes</option>
                          <option value={30}>30 minutes</option>
                          <option value={45}>45 minutes</option>
                          <option value={60}>1 hour</option>
                          <option value={120}>2 hours</option>
                          <option value={180}>3 hours</option>
                          <option value={240}>4 hours</option>
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs={12}>
                      <>
                        <h6>Suggested example text:</h6>
                        <div style={{ fontSize: "0.8rem" }}>
                          1. **Every Day:** Every day of the week. <br />
                          2. **Regular Hours:** From 8:00 AM to 3:00 PM on most
                          days.
                          <br />
                          3. **Exception on Thursdays:** On Thursdays, starts
                          work later, at 10:00 AM, and is available until 3:00
                          PM. <br />
                          4. **Exception on the Second Tuesday of the Month:**
                          On the second Tuesday of each month, starts work at
                          10:00 AM instead of 8:00 AM, and is available until
                          3:00 PM.
                          <br />
                          5. On Vacations From 10th Sept to 20 Sept.
                        </div>
                      </>
                    </Col>
                  </Row>

                  <div className="modal-footer modal-footer-inner">
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() => {
                        this.setState((prevState) => ({
                          dsdInfo: {
                            ...prevState.dsdInfo,
                            availability: values.availability,
                            includeWeekend: values.includeWeekend,
                            includeUSHolidays: values.includeUSHolidays,
                            defaultDuration: values.defaultDuration,
                          },
                        }));
                        this.updateProfile("availabilityInfo", values);
                      }}
                    >
                      Update
                    </Button>
                    <Button
                      variant="outlined"
                      size="sm"
                      className="btn-blue w-140"
                      onClick={() =>
                        this.setState({
                          availabilityInfo: !this.state.availabilityInfo,
                        })
                      }
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  render() {
    let userID = "";
    if (this.props.match.params.id) {
      userID = this.props.match.params.id;
    }

    if (this.state.userType == message.ADMIN && userID == "") {
      return this.adminRender();
    } else {
      if (_.isEmpty(this.state.userData)) {
        return (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        );
      } else {
        if (this.state.userData.usertype === message.ADMIN) {
          return this.adminRender();
        } else {
          return this.agentRender();
        }
      }
    }
  }
}

const mapStateToProps = (state) => {
  return {
    profileData: state.reducer.profileData,
    renderHeader: state.reducer.renderHeader,
  };
};

export default connect(
  mapStateToProps,
  {
    myProfileAction,
    updateProfileAction,
    getAddressFromZipcodeAction,
    updateUserProfileAction,
    getUserCampaignsAction,
    updateUserCampaignDefaultAction,
    getUserPathwaysAction,
    updateUserPathwayDefaultAction,
    updateUserTransPaymentAction,
    getUserTransPaymentAction,
    checkDuplicateInvoicePrefixAction,
    checkDuplicatePublicUrlPostfixAction,
    checkArtistDuplicatePublicUrlAction,
    getShopDetailsAction,
  }
)(UserProfile);
